import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AddressInputType = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  pincode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AgreementInput = {
  agreement?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgreementType = {
  __typename?: 'AgreementType';
  _id?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  requireSignature?: Maybe<Scalars['Boolean']['output']>;
  signatureType?: Maybe<SignatureTypeEnum>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApprovalRecipient = {
  __typename?: 'ApprovalRecipient';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ApprovalRecipientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ApprovalsInput = {
  allowHostsToApprove?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllVisitorResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sendApprovalAlerts?: InputMaybe<SendApprovalAlertsInput>;
};

export type ApprovalsType = {
  __typename?: 'ApprovalsType';
  allowHostsToApprove?: Maybe<Scalars['Boolean']['output']>;
  includeAllVisitorResponses?: Maybe<Scalars['Boolean']['output']>;
  sendApprovalAlerts?: Maybe<SendApprovalAlertsType>;
};

export type AutoSignOutTimeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type AutoSignOutTimeType = {
  __typename?: 'AutoSignOutTimeType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type BookingSpaceInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  resource?: InputMaybe<Scalars['ID']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type BookingSpacePayload = {
  __typename?: 'BookingSpacePayload';
  booking?: Maybe<BookingSpaceType>;
  error?: Maybe<ErrorType>;
};

export type BookingSpaceType = {
  __typename?: 'BookingSpaceType';
  _id?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<SpacesCategoryType>;
  employee?: Maybe<User>;
  end?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<OfficeLocation>;
  resource?: Maybe<SpacesResourceType>;
  space?: Maybe<SpacesType>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type BrandingType = {
  __typename?: 'BrandingType';
  accentColor?: Maybe<Scalars['String']['output']>;
  allowScanning?: Maybe<Scalars['Boolean']['output']>;
  badgeType?: Maybe<Scalars['String']['output']>;
  displaysOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type BrandingTypeInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  allowScanning?: InputMaybe<Scalars['Boolean']['input']>;
  badgeType?: InputMaybe<Scalars['String']['input']>;
  displaysOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryInput = {
  approval?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FieldInput>>>;
  host?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  category?: Maybe<VisitorCategory>;
  error?: Maybe<ErrorType>;
};

export type Company = {
  __typename?: 'Company';
  address?: Maybe<AddressType>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Array<Maybe<OfficeLocation>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ContactLess = {
  __typename?: 'ContactLess';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ContactLessInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  qrCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveriesInput = {
  deliveryInst?: InputMaybe<DeliveryInstInput>;
  general?: InputMaybe<GeneralDeliveryInput>;
};

export type DeliveriesType = {
  __typename?: 'DeliveriesType';
  deliveryInst?: Maybe<DeliveryInstType>;
  general?: Maybe<GeneralDeliveryType>;
};

export enum DeliveryEnum {
  General = 'general',
  Recipient = 'recipient'
}

export type DeliveryInput = {
  collected?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryType?: InputMaybe<DeliveryEnum>;
  location: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  packages?: InputMaybe<Scalars['Int']['input']>;
  reciepient?: InputMaybe<Scalars['ID']['input']>;
  signature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeliveryInstInput = {
  generalDelivery?: InputMaybe<GeneralDeliveryInstInput>;
  recipientDelivery?: InputMaybe<RecipientDeliveryInput>;
};

export type DeliveryInstType = {
  __typename?: 'DeliveryInstType';
  generalDelivery?: Maybe<GeneralDeliveryInstType>;
  recipientDelivery?: Maybe<RecipientDeliveryType>;
};

export type DeliveryList = {
  __typename?: 'DeliveryList';
  count?: Maybe<Scalars['Int']['output']>;
  delivery?: Maybe<Array<Maybe<DeliveryType>>>;
};

export type DeliveryPayload = {
  __typename?: 'DeliveryPayload';
  delivery?: Maybe<DeliveryType>;
  error?: Maybe<ErrorType>;
};

export type DeliveryType = {
  __typename?: 'DeliveryType';
  collected?: Maybe<Scalars['Boolean']['output']>;
  collectedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  delivered?: Maybe<Scalars['DateTime']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<OfficeLocation>;
  note?: Maybe<Scalars['String']['output']>;
  reciepient?: Maybe<User>;
  signature?: Maybe<Scalars['Boolean']['output']>;
};

export type Department = {
  __typename?: 'Department';
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<OfficeLocation>;
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Array<Maybe<User>>>;
};

export type DepartmentInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type DepartmentList = {
  __typename?: 'DepartmentList';
  count?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Array<Maybe<Department>>>;
};

export type DepartmentPayload = {
  __typename?: 'DepartmentPayload';
  department?: Maybe<Department>;
  error?: Maybe<ErrorType>;
};

export type Device = {
  __typename?: 'Device';
  categoryType?: Maybe<Array<Maybe<VisitorCategory>>>;
  company?: Maybe<Company>;
  department?: Maybe<Array<Maybe<Department>>>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<OfficeLocation>;
  sessionKey?: Maybe<Scalars['String']['output']>;
  visitorNotifications?: Maybe<VisitorNotifications>;
};

export type DeviceDeliveryInput = {
  collected?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryType?: InputMaybe<DeliveryEnum>;
  location: Scalars['ID']['input'];
  packages?: InputMaybe<Scalars['Int']['input']>;
  reciepient?: InputMaybe<Scalars['ID']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceInput = {
  categoryType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  department: Array<InputMaybe<Scalars['ID']['input']>>;
  deviceName: Scalars['String']['input'];
  deviceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  visitorNotifications?: InputMaybe<VisitorNotificationsInput>;
};

export type DevicePayload = {
  __typename?: 'DevicePayload';
  device?: Maybe<Device>;
  error?: Maybe<ErrorType>;
  token?: Maybe<Scalars['String']['output']>;
};

export enum DeviceType {
  Mobile = 'Mobile',
  Web = 'Web'
}

export type EmployeePaylaod = {
  __typename?: 'EmployeePaylaod';
  employee?: Maybe<EmployeeTimeline>;
  error?: Maybe<ErrorType>;
};

export type EmployeePocket = {
  __typename?: 'EmployeePocket';
  preRegister?: Maybe<Scalars['Boolean']['output']>;
  signIn?: Maybe<Scalars['Boolean']['output']>;
  verifyEmployee?: Maybe<Scalars['String']['output']>;
};

export type EmployeePocketInput = {
  preRegister?: InputMaybe<Scalars['Boolean']['input']>;
  signIn?: InputMaybe<Scalars['Boolean']['input']>;
  verifyEmployee?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeSettings = {
  __typename?: 'EmployeeSettings';
  generalSetting?: Maybe<GeneralEmployeeSetting>;
  pocket?: Maybe<EmployeePocket>;
  signInQue?: Maybe<Array<Maybe<SignInQueueItem>>>;
  signOutMsg?: Maybe<SignOutMessage>;
};

export type EmployeeSettingsInput = {
  generalSetting?: InputMaybe<GeneralEmployeeSettingInput>;
  pocket?: InputMaybe<EmployeePocketInput>;
  signInQue?: InputMaybe<Array<InputMaybe<SignInQueueItemInput>>>;
  signOutMsg?: InputMaybe<SignOutMessageInput>;
};

export type EmployeeTimeline = {
  __typename?: 'EmployeeTimeline';
  company?: Maybe<Company>;
  employee?: Maybe<User>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<OfficeLocation>;
  returnTime?: Maybe<Scalars['String']['output']>;
  signInQue?: Maybe<Array<Maybe<SignInQue>>>;
  signedIn?: Maybe<Scalars['String']['output']>;
  signedInDevice?: Maybe<Scalars['String']['output']>;
  signedOut?: Maybe<Scalars['String']['output']>;
  signedOutDevice?: Maybe<Scalars['String']['output']>;
  signedType?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export type EmployeeTimelineDeviceInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  returnTime?: InputMaybe<Scalars['String']['input']>;
  signInQue?: InputMaybe<Array<InputMaybe<SignInQueInput>>>;
  signedIn?: InputMaybe<Scalars['String']['input']>;
  signedInDevice?: InputMaybe<DeviceType>;
  signedOut?: InputMaybe<Scalars['String']['input']>;
  signedOutDevice?: InputMaybe<DeviceType>;
  signedType?: InputMaybe<Scalars['String']['input']>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeTimelineInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  returnTime?: InputMaybe<Scalars['String']['input']>;
  signInQue?: InputMaybe<Array<InputMaybe<SignInQueInput>>>;
  signedIn?: InputMaybe<Scalars['String']['input']>;
  signedInDevice?: InputMaybe<DeviceType>;
  signedOut?: InputMaybe<Scalars['String']['input']>;
  signedOutDevice?: InputMaybe<DeviceType>;
  signedType?: InputMaybe<Scalars['String']['input']>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeTimelineList = {
  __typename?: 'EmployeeTimelineList';
  count?: Maybe<Scalars['Int']['output']>;
  employee?: Maybe<Array<Maybe<EmployeeTimeline>>>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Field = {
  __typename?: 'Field';
  clearResponseAfterEachVisit?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FieldInput = {
  clearResponseAfterEachVisit?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralDeliveryContact = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralDeliveryContactType = {
  __typename?: 'GeneralDeliveryContactType';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type GeneralDeliveryInput = {
  allowDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryContact?: InputMaybe<Array<InputMaybe<GeneralDeliveryContact>>>;
  scanDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeneralDeliveryInstInput = {
  noSignature?: InputMaybe<Scalars['String']['input']>;
  signatureRquired?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralDeliveryInstType = {
  __typename?: 'GeneralDeliveryInstType';
  noSignature?: Maybe<Scalars['String']['output']>;
  signatureRquired?: Maybe<Scalars['String']['output']>;
};

export type GeneralDeliveryType = {
  __typename?: 'GeneralDeliveryType';
  allowDelivery?: Maybe<Scalars['Boolean']['output']>;
  deliveryContact?: Maybe<Array<Maybe<GeneralDeliveryContactType>>>;
  scanDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type GeneralEmployeeSetting = {
  __typename?: 'GeneralEmployeeSetting';
  signOutTime?: Maybe<Scalars['String']['output']>;
  updatePicture?: Maybe<Scalars['Boolean']['output']>;
  verifyPhoto?: Maybe<Scalars['Boolean']['output']>;
  workRemotely?: Maybe<Scalars['Boolean']['output']>;
};

export type GeneralEmployeeSettingInput = {
  signOutTime?: InputMaybe<Scalars['String']['input']>;
  updatePicture?: InputMaybe<Scalars['Boolean']['input']>;
  verifyPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  workRemotely?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoogleChatType = {
  __typename?: 'GoogleChatType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  webhooks?: Maybe<Array<Maybe<HookType>>>;
};

export type HookType = {
  __typename?: 'HookType';
  name?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type IntegrationType = {
  __typename?: 'IntegrationType';
  googleChat?: Maybe<GoogleChatType>;
  msTeams?: Maybe<MsTeamsType>;
};

export type LocationPaylaod = {
  __typename?: 'LocationPaylaod';
  error?: Maybe<ErrorType>;
  location?: Maybe<OfficeLocation>;
};

export type MsTeamsChannelInput = {
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
};

export type MsTeamsChannelType = {
  __typename?: 'MsTeamsChannelType';
  channelId?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
};

export type MsTeamsType = {
  __typename?: 'MsTeamsType';
  channels?: Maybe<Array<Maybe<MsTeamsChannelType>>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addBookingSpace?: Maybe<BookingSpacePayload>;
  addLocation?: Maybe<LocationPaylaod>;
  addResources?: Maybe<SpacesResourcePayload>;
  addSpaceCategory?: Maybe<SpacesCategoryPayload>;
  addSpaces?: Maybe<SpacesPaylaod>;
  addTabImg?: Maybe<Scalars['String']['output']>;
  authLogin?: Maybe<UserPaylaod>;
  createAgreement?: Maybe<AgreementType>;
  createBulkUsers?: Maybe<UserList>;
  createCategory?: Maybe<CategoryType>;
  createDelivery?: Maybe<DeliveryPayload>;
  createDepartment?: Maybe<DepartmentPayload>;
  createDevice?: Maybe<DevicePayload>;
  createDeviceDelivery?: Maybe<DeliveryPayload>;
  createEmployeeTimeline?: Maybe<EmployeePaylaod>;
  createPreRegister?: Maybe<PreRegisterPayload>;
  createUser?: Maybe<UserPaylaod>;
  createVisitor?: Maybe<VisitorPaylaod>;
  createdEmployeeTimelineDevice?: Maybe<EmployeePaylaod>;
  deleteAgreement?: Maybe<Scalars['String']['output']>;
  deleteCategory?: Maybe<Scalars['String']['output']>;
  deleteDelivery?: Maybe<Scalars['String']['output']>;
  deleteDepartment?: Maybe<Scalars['String']['output']>;
  deleteDevice?: Maybe<DevicePayload>;
  deleteEmployee?: Maybe<UserPaylaod>;
  deleteField?: Maybe<Scalars['String']['output']>;
  deleteLocation?: Maybe<LocationPaylaod>;
  deletePreRegister?: Maybe<PreRegisterPayload>;
  deviceLogin?: Maybe<DevicePayload>;
  employeeLogin?: Maybe<UserPaylaod>;
  generateResetOtp?: Maybe<UserPaylaod>;
  removeIntegration?: Maybe<IntegrationType>;
  removeMsTeamsIntegration?: Maybe<IntegrationType>;
  reorderCategories?: Maybe<Scalars['String']['output']>;
  reorderFields?: Maybe<Scalars['String']['output']>;
  resetPasword?: Maybe<UserPaylaod>;
  restoreEmployee?: Maybe<UserPaylaod>;
  saveMsTeamsChannel?: Maybe<IntegrationType>;
  signup?: Maybe<UserPaylaod>;
  updateCategory?: Maybe<CategoryType>;
  updateCompany?: Maybe<Scalars['String']['output']>;
  updateCompanyImgs?: Maybe<Scalars['String']['output']>;
  updateDelivery?: Maybe<DeliveryPayload>;
  updateDevice?: Maybe<DevicePayload>;
  updateField?: Maybe<Scalars['String']['output']>;
  updateResource?: Maybe<SpacesResourcePayload>;
  updateSpace?: Maybe<SpacesPaylaod>;
  updateSpaceCategory?: Maybe<SpacesCategoryPayload>;
  updateUser?: Maybe<UserPaylaod>;
  updateVisitor?: Maybe<VisitorPaylaod>;
  updateVisitorStatus?: Maybe<VisitorPaylaod>;
  verifyEmployee?: Maybe<UserPaylaod>;
  verifyOtp?: Maybe<UserPaylaod>;
};


export type MutationAddBookingSpaceArgs = {
  input?: InputMaybe<BookingSpaceInput>;
};


export type MutationAddLocationArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  customHeading?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddResourcesArgs = {
  input?: InputMaybe<SpacesResourceInput>;
};


export type MutationAddSpaceCategoryArgs = {
  input?: InputMaybe<SpacesCategoryInputType>;
};


export type MutationAddSpacesArgs = {
  input?: InputMaybe<SpacesInputType>;
};


export type MutationAddTabImgArgs = {
  locationId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthLoginArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAgreementArgs = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  requireSignature?: InputMaybe<Scalars['Boolean']['input']>;
  signatureType?: InputMaybe<SignatureTypeEnum>;
  title: Scalars['String']['input'];
};


export type MutationCreateBulkUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<UserInput>>>;
};


export type MutationCreateCategoryArgs = {
  input?: InputMaybe<CategoryInput>;
};


export type MutationCreateDeliveryArgs = {
  input?: InputMaybe<DeliveryInput>;
};


export type MutationCreateDepartmentArgs = {
  input?: InputMaybe<DepartmentInput>;
};


export type MutationCreateDeviceArgs = {
  input?: InputMaybe<DeviceInput>;
};


export type MutationCreateDeviceDeliveryArgs = {
  input?: InputMaybe<DeviceDeliveryInput>;
};


export type MutationCreateEmployeeTimelineArgs = {
  input?: InputMaybe<EmployeeTimelineInput>;
};


export type MutationCreatePreRegisterArgs = {
  input?: InputMaybe<PreRegisterInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationCreateVisitorArgs = {
  input?: InputMaybe<VisitorInput>;
};


export type MutationCreatedEmployeeTimelineDeviceArgs = {
  input?: InputMaybe<EmployeeTimelineDeviceInput>;
};


export type MutationDeleteAgreementArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCategoryArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteDeliveryArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteDepartmentArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteFieldArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  fieldId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationDeletePreRegisterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceLoginArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEmployeeLoginArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateResetOtpArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveIntegrationArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  webhookId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationReorderCategoriesArgs = {
  items: Array<InputMaybe<ReorderItemInput>>;
};


export type MutationReorderFieldsArgs = {
  categoryId: Scalars['ID']['input'];
  items: Array<InputMaybe<ReorderItemInput>>;
};


export type MutationResetPaswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRestoreEmployeeArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSaveMsTeamsChannelArgs = {
  channels: Array<InputMaybe<MsTeamsChannelInput>>;
  teamId: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  input?: InputMaybe<SignUpInputType>;
};


export type MutationUpdateCategoryArgs = {
  input?: InputMaybe<UpdateCategoryInput>;
};


export type MutationUpdateCompanyArgs = {
  input?: InputMaybe<UpdateCompanyInput>;
};


export type MutationUpdateCompanyImgsArgs = {
  imgs?: InputMaybe<Array<InputMaybe<TabImgInput>>>;
  locationId: Scalars['ID']['input'];
};


export type MutationUpdateDeliveryArgs = {
  input?: InputMaybe<UpdateDeliveryInput>;
};


export type MutationUpdateDeviceArgs = {
  input?: InputMaybe<UpdateDeviceInput>;
};


export type MutationUpdateFieldArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  clearResponseAfterEachVisit?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateResourceArgs = {
  _id: Scalars['ID']['input'];
  input?: InputMaybe<SpacesResourceInput>;
};


export type MutationUpdateSpaceArgs = {
  _id: Scalars['ID']['input'];
  input?: InputMaybe<SpacesInputType>;
};


export type MutationUpdateSpaceCategoryArgs = {
  _id: Scalars['ID']['input'];
  input?: InputMaybe<SpacesCategoryInputType>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateVisitorArgs = {
  input?: InputMaybe<UpdateVisitorInput>;
};


export type MutationUpdateVisitorStatusArgs = {
  visitorId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationVerifyEmployeeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyOtpArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
};

export type NotifyIfNotSignedOutInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['String']['input']>;
};

export type NotifyIfNotSignedOutType = {
  __typename?: 'NotifyIfNotSignedOutType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
};

export type OfficeLocation = {
  __typename?: 'OfficeLocation';
  address?: Maybe<Scalars['String']['output']>;
  agreements?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  approvals?: Maybe<ApprovalsType>;
  branding?: Maybe<BrandingType>;
  company?: Maybe<Company>;
  contactLess?: Maybe<ContactLess>;
  customHeading?: Maybe<Scalars['String']['output']>;
  deliveries?: Maybe<DeliveriesType>;
  devices?: Maybe<Array<Maybe<Device>>>;
  employees?: Maybe<EmployeeSettings>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  returningVisitors?: Maybe<ReturningVisitorsType>;
  savedImgs?: Maybe<Array<Maybe<SavedImgsType>>>;
  selectHost?: Maybe<SelectHostType>;
  selectedAgreement?: Maybe<SelectedAgreement>;
  signInNotifications?: Maybe<SignInNotificationsType>;
  signOutSettings?: Maybe<SignOutSettingsType>;
  visitorButton?: Maybe<VisitorButton>;
  visitorPhoto?: Maybe<Scalars['Boolean']['output']>;
};

export type PreRegisterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  visitorEmail?: InputMaybe<Scalars['String']['input']>;
};

export type PreRegisterList = {
  __typename?: 'PreRegisterList';
  count?: Maybe<Scalars['Int']['output']>;
  visitors?: Maybe<Array<Maybe<PreRegisterType>>>;
};

export type PreRegisterPayload = {
  __typename?: 'PreRegisterPayload';
  error?: Maybe<ErrorType>;
  visitor?: Maybe<PreRegisterType>;
};

export type PreRegisterType = {
  __typename?: 'PreRegisterType';
  address?: Maybe<Scalars['String']['output']>;
  category?: Maybe<VisitorCategory>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  department?: Maybe<Department>;
  employees?: Maybe<Array<Maybe<User>>>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  visitorEmail?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  deviceMe?: Maybe<DevicePayload>;
  getAgreement?: Maybe<AgreementType>;
  getAgreements?: Maybe<Array<Maybe<AgreementType>>>;
  getArchivedEmployees?: Maybe<UserList>;
  getBookingSpaces?: Maybe<Array<Maybe<BookingSpaceType>>>;
  getCategories?: Maybe<Array<Maybe<VisitorCategory>>>;
  getCompanyDetails?: Maybe<Company>;
  getDeliveries?: Maybe<DeliveryList>;
  getDepartments?: Maybe<DepartmentList>;
  getDeviceDeliveries?: Maybe<Array<Maybe<DeliveryType>>>;
  getDeviceDepartments?: Maybe<DepartmentList>;
  getDeviceUsers?: Maybe<UserList>;
  getDeviceVisiotr?: Maybe<VisitorList>;
  getDevices?: Maybe<Array<Maybe<Device>>>;
  getEmployeeTimeline?: Maybe<EmployeeTimelineList>;
  getEmployeesTimeline?: Maybe<EmployeeTimelineList>;
  getField?: Maybe<Array<Maybe<Field>>>;
  getIntegrations?: Maybe<IntegrationType>;
  getOfficeLocation?: Maybe<OfficeLocation>;
  getOfficeLocations?: Maybe<Array<Maybe<OfficeLocation>>>;
  getPreVisitors?: Maybe<PreRegisterList>;
  getResourceSchedule?: Maybe<Array<Maybe<ResourceSchedule>>>;
  getSpaceCategories?: Maybe<Array<Maybe<SpacesCategoryType>>>;
  getSpaceResource?: Maybe<Array<Maybe<SpacesResourceType>>>;
  getSpaces?: Maybe<Array<Maybe<SpacesType>>>;
  getUsers?: Maybe<UserList>;
  getVistors?: Maybe<VisitorList>;
  me?: Maybe<User>;
};


export type QueryDeviceMeArgs = {
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAgreementArgs = {
  agreementId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAgreementsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetArchivedEmployeesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBookingSpacesArgs = {
  employee?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  resource?: InputMaybe<Scalars['ID']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCategoriesArgs = {
  location: Scalars['ID']['input'];
};


export type QueryGetDeliveriesArgs = {
  collected?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<SortedInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDepartmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeviceDeliveriesArgs = {
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeviceDepartmentsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeviceUsersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeviceVisiotrArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  remembered?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDevicesArgs = {
  location: Scalars['ID']['input'];
};


export type QueryGetEmployeeTimelineArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmployeesTimelineArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedType?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<SortedInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFieldArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetOfficeLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryGetPreVisitorsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<SortedInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetResourceScheduleArgs = {
  endDate: Scalars['String']['input'];
  location: Scalars['ID']['input'];
  resourceCategory?: InputMaybe<Scalars['ID']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryGetSpaceCategoriesArgs = {
  location: Scalars['ID']['input'];
};


export type QueryGetSpaceResourceArgs = {
  features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location: Scalars['ID']['input'];
  resourceCategory?: InputMaybe<Scalars['ID']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSpacesArgs = {
  location: Scalars['ID']['input'];
  resourceCategory?: InputMaybe<Scalars['ID']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<RoleEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<SortedInput>;
};


export type QueryGetVistorsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  remembered?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedType?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<SortedInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type RecipientDeliveryInput = {
  noSignature?: InputMaybe<Scalars['String']['input']>;
  recipientOut?: InputMaybe<Scalars['String']['input']>;
  signatureRquired?: InputMaybe<Scalars['String']['input']>;
};

export type RecipientDeliveryType = {
  __typename?: 'RecipientDeliveryType';
  noSignature?: Maybe<Scalars['String']['output']>;
  recipientOut?: Maybe<Scalars['String']['output']>;
  signatureRquired?: Maybe<Scalars['String']['output']>;
};

export type ReorderItemInput = {
  id: Scalars['ID']['input'];
  priority: Scalars['Int']['input'];
};

export type ResourceSchedule = {
  __typename?: 'ResourceSchedule';
  _id?: Maybe<Scalars['ID']['output']>;
  bookings?: Maybe<Array<Maybe<SimpleBookingTime>>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  resourceName?: Maybe<Scalars['String']['output']>;
};

export type ReturningVisitorsInput = {
  displayNameMatches?: InputMaybe<Scalars['Boolean']['input']>;
  saveDetails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReturningVisitorsType = {
  __typename?: 'ReturningVisitorsType';
  displayNameMatches?: Maybe<Scalars['Boolean']['output']>;
  saveDetails?: Maybe<Scalars['Boolean']['output']>;
};

export enum RoleEnum {
  Admin = 'Admin',
  Employee = 'Employee',
  Manager = 'Manager'
}

export type SavedImgsType = {
  __typename?: 'SavedImgsType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SelectHostInput = {
  allowOnStaticQR?: InputMaybe<Scalars['Boolean']['input']>;
  displayHostStatus?: InputMaybe<Scalars['Boolean']['input']>;
  requireVisitors?: InputMaybe<Scalars['Boolean']['input']>;
  showList?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SelectHostType = {
  __typename?: 'SelectHostType';
  allowOnStaticQR?: Maybe<Scalars['Boolean']['output']>;
  displayHostStatus?: Maybe<Scalars['Boolean']['output']>;
  requireVisitors?: Maybe<Scalars['Boolean']['output']>;
  showList?: Maybe<Scalars['Boolean']['output']>;
};

export type SelectedAgreement = {
  __typename?: 'SelectedAgreement';
  agreement?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['Boolean']['output']>;
};

export type SendApprovalAlertsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<ApprovalRecipientInput>>>;
};

export type SendApprovalAlertsType = {
  __typename?: 'SendApprovalAlertsType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  recipients?: Maybe<Array<Maybe<ApprovalRecipient>>>;
};

export type SignInNotificationRecipient = {
  __typename?: 'SignInNotificationRecipient';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SignInNotificationRecipientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SignInNotificationsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<SignInNotificationRecipientInput>>>;
};

export type SignInNotificationsType = {
  __typename?: 'SignInNotificationsType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  recipients?: Maybe<Array<Maybe<SignInNotificationRecipient>>>;
};

export type SignInQue = {
  __typename?: 'SignInQue';
  answer?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SignInQueueItem = {
  __typename?: 'SignInQueueItem';
  _id?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SignInQueueItemInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SignOutMessage = {
  __typename?: 'SignOutMessage';
  msgs?: Maybe<Array<Maybe<MsgType>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type SignOutMessageInput = {
  msgs?: InputMaybe<Array<InputMaybe<MsgTypeInput>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignOutSettingsInput = {
  autoSignOutTime?: InputMaybe<AutoSignOutTimeInput>;
  notifyIfNotSignedOut?: InputMaybe<NotifyIfNotSignedOutInput>;
  notifyOnSignOut?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignOutSettingsType = {
  __typename?: 'SignOutSettingsType';
  autoSignOutTime?: Maybe<AutoSignOutTimeType>;
  notifyIfNotSignedOut?: Maybe<NotifyIfNotSignedOutType>;
  notifyOnSignOut?: Maybe<Scalars['Boolean']['output']>;
};

export type SignUpInputType = {
  address?: InputMaybe<AddressInputType>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};

export enum SignatureTypeEnum {
  Checkbox = 'CHECKBOX',
  Signature = 'SIGNATURE'
}

export type SimpleBookingTime = {
  __typename?: 'SimpleBookingTime';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type SortedInput = {
  columnId?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
};

export type SpacesCategoryInputType = {
  icon?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SpacesCategoryPayload = {
  __typename?: 'SpacesCategoryPayload';
  category?: Maybe<SpacesCategoryType>;
  error?: Maybe<ErrorType>;
};

export type SpacesCategoryType = {
  __typename?: 'SpacesCategoryType';
  _id?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  location?: Maybe<OfficeLocation>;
  name?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Maybe<SpacesResourceType>>>;
};

export type SpacesInputType = {
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type SpacesPaylaod = {
  __typename?: 'SpacesPaylaod';
  error?: Maybe<ErrorType>;
  spaces?: Maybe<SpacesType>;
};

export type SpacesResourceInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  resourceCategory?: InputMaybe<Scalars['ID']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
};

export type SpacesResourcePayload = {
  __typename?: 'SpacesResourcePayload';
  error?: Maybe<ErrorType>;
  resource?: Maybe<SpacesResourceType>;
};

export type SpacesResourceType = {
  __typename?: 'SpacesResourceType';
  _id?: Maybe<Scalars['ID']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  employees?: Maybe<Array<Maybe<User>>>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<OfficeLocation>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  resourceCategory?: Maybe<SpacesCategoryType>;
  space?: Maybe<SpacesType>;
};

export type SpacesType = {
  __typename?: 'SpacesType';
  _id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<OfficeLocation>;
  name?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Array<Maybe<SpacesResourceType>>>;
};

export type TabImgInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  approval?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<UpdateFieldInput>>>;
  host?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCompanyInput = {
  approvals?: InputMaybe<ApprovalsInput>;
  branding?: InputMaybe<BrandingTypeInput>;
  contactLess?: InputMaybe<ContactLessInput>;
  customHeading?: InputMaybe<Scalars['String']['input']>;
  deliveries?: InputMaybe<DeliveriesInput>;
  employees?: InputMaybe<EmployeeSettingsInput>;
  locationId: Scalars['ID']['input'];
  returningVisitors?: InputMaybe<ReturningVisitorsInput>;
  selectHost?: InputMaybe<SelectHostInput>;
  selectedAgreement?: InputMaybe<AgreementInput>;
  signInNotifications?: InputMaybe<SignInNotificationsInput>;
  signOutSettings?: InputMaybe<SignOutSettingsInput>;
  visitorButton?: InputMaybe<VisitorButtonInput>;
  visitorPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeliveryInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  collected?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryType?: InputMaybe<DeliveryEnum>;
  location: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  packages?: InputMaybe<Scalars['Int']['input']>;
  reciepient?: InputMaybe<Scalars['ID']['input']>;
  signature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeviceInput = {
  _id: Scalars['ID']['input'];
  categoryType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  visitorNotifications?: InputMaybe<VisitorNotificationsInput>;
};

export type UpdateFieldInput = {
  clearResponseAfterEachVisit?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  notificationPreference?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateUserStatusInput>;
  workingRemote?: InputMaybe<Scalars['String']['input']>;
};

export enum UpdateUserStatusInput {
  In = 'IN',
  Out = 'OUT'
}

export type UpdateVisitorInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  anonymize?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  preRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  remembered?: InputMaybe<Scalars['Boolean']['input']>;
  signedInDevice?: InputMaybe<Scalars['String']['input']>;
  signedOutDevice?: InputMaybe<Scalars['String']['input']>;
  signedType?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  department?: Maybe<Department>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<OfficeLocation>;
  notificationPreference?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleEnum>;
  timeline?: Maybe<EmployeeTimeline>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workingRemote?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  notificationPreference?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatusInput>;
  workingRemote?: InputMaybe<Scalars['String']['input']>;
};

export type UserList = {
  __typename?: 'UserList';
  count?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Array<Maybe<User>>>;
};

export type UserPaylaod = {
  __typename?: 'UserPaylaod';
  error?: Maybe<ErrorType>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum UserStatusInput {
  In = 'IN',
  Out = 'OUT'
}

export type Visitor = {
  __typename?: 'Visitor';
  anonymize?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<VisitorCategory>;
  data?: Maybe<Scalars['JSON']['output']>;
  department?: Maybe<Department>;
  employees?: Maybe<Array<Maybe<User>>>;
  id?: Maybe<Scalars['ID']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  isReturning?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<OfficeLocation>;
  remembered?: Maybe<Scalars['Boolean']['output']>;
  selectedAgreement?: Maybe<VisitorAgreement>;
  signedIn?: Maybe<Scalars['DateTime']['output']>;
  signedInDevice?: Maybe<Scalars['String']['output']>;
  signedOut?: Maybe<Scalars['DateTime']['output']>;
  signedOutDevice?: Maybe<Scalars['String']['output']>;
  signedType?: Maybe<Scalars['String']['output']>;
};

export type VisitorAgreement = {
  __typename?: 'VisitorAgreement';
  agreement?: Maybe<Scalars['String']['output']>;
  signatureImg?: Maybe<Scalars['String']['output']>;
};

export type VisitorButton = {
  __typename?: 'VisitorButton';
  buttonBg?: Maybe<Scalars['String']['output']>;
  buttonColor?: Maybe<Scalars['String']['output']>;
  buttonRadius?: Maybe<Scalars['String']['output']>;
};

export type VisitorButtonInput = {
  buttonBg?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonRadius?: InputMaybe<Scalars['String']['input']>;
};

export type VisitorCategory = {
  __typename?: 'VisitorCategory';
  approval?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<Maybe<Field>>>;
  host?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type VisitorInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  isReturning?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['ID']['input'];
  remembered?: InputMaybe<Scalars['Boolean']['input']>;
  selectedAgreement?: InputMaybe<VisitorInputAgreement>;
  signedInDevice?: InputMaybe<DeviceType>;
  signedOutDevice?: InputMaybe<DeviceType>;
  signedType?: InputMaybe<Scalars['String']['input']>;
};

export type VisitorInputAgreement = {
  agreement?: InputMaybe<Scalars['String']['input']>;
  signatureImg?: InputMaybe<Scalars['String']['input']>;
};

export type VisitorList = {
  __typename?: 'VisitorList';
  count?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<ErrorType>;
  visitor?: Maybe<Array<Maybe<Visitor>>>;
};

export type VisitorNotifications = {
  __typename?: 'VisitorNotifications';
  checkIn?: Maybe<Scalars['String']['output']>;
  checkInPending?: Maybe<Scalars['String']['output']>;
  checkOut?: Maybe<Scalars['String']['output']>;
};

export type VisitorNotificationsInput = {
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkInPending?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
};

export type VisitorPaylaod = {
  __typename?: 'VisitorPaylaod';
  count?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<ErrorType>;
  visitor?: Maybe<Visitor>;
};

export type MsgType = {
  __typename?: 'msgType';
  _id?: Maybe<Scalars['String']['output']>;
  msg?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type MsgTypeInput = {
  msg?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignInQueInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgreementMutationVariables = Exact<{
  content: Scalars['String']['input'];
  createAgreementId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  signatureType?: InputMaybe<SignatureTypeEnum>;
  requireSignature?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAgreementMutation = { __typename?: 'Mutation', createAgreement?: { __typename?: 'AgreementType', _id?: string | null, title?: string | null, content?: string | null, signatureType?: SignatureTypeEnum | null, requireSignature?: boolean | null } | null };

export type AddBookingSpaceMutationVariables = Exact<{
  input?: InputMaybe<BookingSpaceInput>;
}>;


export type AddBookingSpaceMutation = { __typename?: 'Mutation', addBookingSpace?: { __typename?: 'BookingSpacePayload', error?: { __typename?: 'ErrorType', code: string, message: string } | null, booking?: { __typename?: 'BookingSpaceType', _id?: string | null } | null } | null };

export type AddLocationMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddLocationMutation = { __typename?: 'Mutation', addLocation?: { __typename?: 'LocationPaylaod', location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null } | null };

export type AddResourcesMutationVariables = Exact<{
  input?: InputMaybe<SpacesResourceInput>;
}>;


export type AddResourcesMutation = { __typename?: 'Mutation', addResources?: { __typename?: 'SpacesResourcePayload', error?: { __typename?: 'ErrorType', code: string, message: string } | null, resource?: { __typename?: 'SpacesResourceType', name?: string | null, _id?: string | null } | null } | null };

export type AddSpacesMutationVariables = Exact<{
  input?: InputMaybe<SpacesInputType>;
}>;


export type AddSpacesMutation = { __typename?: 'Mutation', addSpaces?: { __typename?: 'SpacesPaylaod', error?: { __typename?: 'ErrorType', code: string, message: string } | null, spaces?: { __typename?: 'SpacesType', name?: string | null, _id?: string | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, resource?: Array<{ __typename?: 'SpacesResourceType', name?: string | null, _id?: string | null } | null> | null } | null } | null };

export type AddSpaceCategoryMutationVariables = Exact<{
  input?: InputMaybe<SpacesCategoryInputType>;
}>;


export type AddSpaceCategoryMutation = { __typename?: 'Mutation', addSpaceCategory?: { __typename?: 'SpacesCategoryPayload', error?: { __typename?: 'ErrorType', code: string, message: string } | null, category?: { __typename?: 'SpacesCategoryType', _id?: string | null, name?: string | null } | null } | null };

export type AddTabImgMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
}>;


export type AddTabImgMutation = { __typename?: 'Mutation', addTabImg?: string | null };

export type AuthLoginMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthLoginMutation = { __typename?: 'Mutation', authLogin?: { __typename?: 'UserPaylaod', token?: string | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, role?: RoleEnum | null, phone?: string | null, createdAt?: any | null, updatedAt?: any | null } | null, error?: { __typename?: 'ErrorType', message: string, code: string } | null } | null };

export type CreateBulkUsersMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UserInput>> | InputMaybe<UserInput>>;
}>;


export type CreateBulkUsersMutation = { __typename?: 'Mutation', createBulkUsers?: { __typename?: 'UserList', count?: number | null, user?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null } | null> | null } | null };

export type CreateCategoryMutationVariables = Exact<{
  input?: InputMaybe<CategoryInput>;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory?: { __typename?: 'CategoryType', category?: { __typename?: 'VisitorCategory', id?: string | null, name?: string | null, fields?: Array<{ __typename?: 'Field', name?: string | null, label?: string | null, type?: string | null, enabled?: boolean | null } | null> | null } | null, error?: { __typename?: 'ErrorType', message: string, code: string } | null } | null };

export type CreateDeliveryMutationVariables = Exact<{
  input?: InputMaybe<DeliveryInput>;
}>;


export type CreateDeliveryMutation = { __typename?: 'Mutation', createDelivery?: { __typename?: 'DeliveryPayload', error?: { __typename?: 'ErrorType', code: string, message: string } | null, delivery?: { __typename?: 'DeliveryType', id?: string | null } | null } | null };

export type CreateDepartmentMutationVariables = Exact<{
  input?: InputMaybe<DepartmentInput>;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment?: { __typename?: 'DepartmentPayload', department?: { __typename?: 'Department', id?: string | null, name?: string | null, user?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, role?: RoleEnum | null } | null> | null } | null, error?: { __typename?: 'ErrorType', message: string, code: string } | null } | null };

export type CreateDeviceMutationVariables = Exact<{
  input?: InputMaybe<DeviceInput>;
}>;


export type CreateDeviceMutation = { __typename?: 'Mutation', createDevice?: { __typename?: 'DevicePayload', error?: { __typename?: 'ErrorType', code: string, message: string } | null, device?: { __typename?: 'Device', id?: string | null, deviceName?: string | null, deviceId?: string | null } | null } | null };

export type CreatePreRegisterMutationVariables = Exact<{
  input?: InputMaybe<PreRegisterInput>;
}>;


export type CreatePreRegisterMutation = { __typename?: 'Mutation', createPreRegister?: { __typename?: 'PreRegisterPayload', visitor?: { __typename?: 'PreRegisterType', id?: string | null, data?: any | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type CreatedEmployeeTimelineDeviceMutationVariables = Exact<{
  input?: InputMaybe<EmployeeTimelineDeviceInput>;
}>;


export type CreatedEmployeeTimelineDeviceMutation = { __typename?: 'Mutation', createdEmployeeTimelineDevice?: { __typename?: 'EmployeePaylaod', error?: { __typename?: 'ErrorType', code: string, message: string } | null, employee?: { __typename?: 'EmployeeTimeline', id?: string | null } | null } | null };

export type CreateUserMutationVariables = Exact<{
  input?: InputMaybe<UserInput>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'UserPaylaod', user?: { __typename?: 'User', id?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type CreateVisitorMutationVariables = Exact<{
  input?: InputMaybe<VisitorInput>;
}>;


export type CreateVisitorMutation = { __typename?: 'Mutation', createVisitor?: { __typename?: 'VisitorPaylaod', visitor?: { __typename?: 'Visitor', id?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type DeleteAgreementMutationVariables = Exact<{
  deleteAgreementId: Scalars['String']['input'];
}>;


export type DeleteAgreementMutation = { __typename?: 'Mutation', deleteAgreement?: string | null };

export type DeleteCategoryMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory?: string | null };

export type DeleteDeliveryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteDeliveryMutation = { __typename?: 'Mutation', deleteDelivery?: string | null };

export type DeleteDepartmentMutationVariables = Exact<{
  departmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteDepartmentMutation = { __typename?: 'Mutation', deleteDepartment?: string | null };

export type DeleteDeviceMutationVariables = Exact<{
  deleteDeviceId: Scalars['ID']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'Mutation', deleteDevice?: { __typename?: 'DevicePayload', device?: { __typename?: 'Device', id?: string | null, deviceName?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type DeleteEmployeeMutationVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee?: { __typename?: 'UserPaylaod', user?: { __typename?: 'User', id?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type DeleteFieldMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  fieldId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteFieldMutation = { __typename?: 'Mutation', deleteField?: string | null };

export type DeleteLocationMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation?: { __typename?: 'LocationPaylaod', error?: { __typename?: 'ErrorType', code: string, message: string } | null, location?: { __typename?: 'OfficeLocation', id?: string | null } | null } | null };

export type DeletePreRegisterMutationVariables = Exact<{
  deletePreRegisterId: Scalars['ID']['input'];
}>;


export type DeletePreRegisterMutation = { __typename?: 'Mutation', deletePreRegister?: { __typename?: 'PreRegisterPayload', error?: { __typename?: 'ErrorType', message: string, code: string } | null, visitor?: { __typename?: 'PreRegisterType', id?: string | null } | null } | null };

export type RemoveIntegrationMutationVariables = Exact<{
  webhookId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveIntegrationMutation = { __typename?: 'Mutation', removeIntegration?: { __typename?: 'IntegrationType', googleChat?: { __typename?: 'GoogleChatType', enabled?: boolean | null, webhooks?: Array<{ __typename?: 'HookType', name?: string | null, webhookUrl?: string | null } | null> | null } | null, msTeams?: { __typename?: 'MsTeamsType', teamId?: string | null, tenantId?: string | null, enabled?: boolean | null, channels?: Array<{ __typename?: 'MsTeamsChannelType', channelId?: string | null, channelName?: string | null } | null> | null } | null } | null };

export type RemoveMsTeamsIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveMsTeamsIntegrationMutation = { __typename?: 'Mutation', removeMsTeamsIntegration?: { __typename?: 'IntegrationType', googleChat?: { __typename?: 'GoogleChatType', enabled?: boolean | null, webhooks?: Array<{ __typename?: 'HookType', name?: string | null, webhookUrl?: string | null } | null> | null } | null, msTeams?: { __typename?: 'MsTeamsType', teamId?: string | null, tenantId?: string | null, enabled?: boolean | null, channels?: Array<{ __typename?: 'MsTeamsChannelType', channelId?: string | null, channelName?: string | null } | null> | null } | null } | null };

export type ReorderCategoriesMutationVariables = Exact<{
  items: Array<InputMaybe<ReorderItemInput>> | InputMaybe<ReorderItemInput>;
}>;


export type ReorderCategoriesMutation = { __typename?: 'Mutation', reorderCategories?: string | null };

export type ReorderFieldsMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  items: Array<InputMaybe<ReorderItemInput>> | InputMaybe<ReorderItemInput>;
}>;


export type ReorderFieldsMutation = { __typename?: 'Mutation', reorderFields?: string | null };

export type GenerateResetOtpMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateResetOtpMutation = { __typename?: 'Mutation', generateResetOtp?: { __typename?: 'UserPaylaod', token?: string | null, error?: { __typename?: 'ErrorType', message: string, code: string } | null, user?: { __typename?: 'User', firstName?: string | null, id?: string | null } | null } | null };

export type ResetPaswordMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResetPaswordMutation = { __typename?: 'Mutation', resetPasword?: { __typename?: 'UserPaylaod', token?: string | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null } | null } | null };

export type RestoreEmployeeMutationVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RestoreEmployeeMutation = { __typename?: 'Mutation', restoreEmployee?: { __typename?: 'UserPaylaod', user?: { __typename?: 'User', id?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type SaveMsTeamsChannelMutationVariables = Exact<{
  teamId: Scalars['String']['input'];
  channels: Array<InputMaybe<MsTeamsChannelInput>> | InputMaybe<MsTeamsChannelInput>;
}>;


export type SaveMsTeamsChannelMutation = { __typename?: 'Mutation', saveMsTeamsChannel?: { __typename?: 'IntegrationType', googleChat?: { __typename?: 'GoogleChatType', enabled?: boolean | null, webhooks?: Array<{ __typename?: 'HookType', name?: string | null, webhookUrl?: string | null } | null> | null } | null, msTeams?: { __typename?: 'MsTeamsType', teamId?: string | null, tenantId?: string | null, enabled?: boolean | null, channels?: Array<{ __typename?: 'MsTeamsChannelType', channelId?: string | null, channelName?: string | null } | null> | null } | null } | null };

export type SignupMutationVariables = Exact<{
  input?: InputMaybe<SignUpInputType>;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup?: { __typename?: 'UserPaylaod', token?: string | null, user?: { __typename?: 'User', phone?: string | null, firstName?: string | null, id?: string | null, role?: RoleEnum | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type UpdateFieldMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  clearResponseAfterEachVisit?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateFieldMutation = { __typename?: 'Mutation', updateField?: string | null };

export type UpdateCategoryMutationVariables = Exact<{
  input?: InputMaybe<UpdateCategoryInput>;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'CategoryType', category?: { __typename?: 'VisitorCategory', id?: string | null, name?: string | null, fields?: Array<{ __typename?: 'Field', name?: string | null, label?: string | null, type?: string | null, enabled?: boolean | null } | null> | null } | null, error?: { __typename?: 'ErrorType', message: string, code: string } | null } | null };

export type UpdateCompanyMutationVariables = Exact<{
  input?: InputMaybe<UpdateCompanyInput>;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: string | null };

export type UpdateCompanyImgsMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  imgs?: InputMaybe<Array<InputMaybe<TabImgInput>> | InputMaybe<TabImgInput>>;
}>;


export type UpdateCompanyImgsMutation = { __typename?: 'Mutation', updateCompanyImgs?: string | null };

export type UpdateDeliveryMutationVariables = Exact<{
  input?: InputMaybe<UpdateDeliveryInput>;
}>;


export type UpdateDeliveryMutation = { __typename?: 'Mutation', updateDelivery?: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryType', id?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type UpdateDeviceMutationVariables = Exact<{
  input?: InputMaybe<UpdateDeviceInput>;
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateDevice?: { __typename?: 'DevicePayload', device?: { __typename?: 'Device', id?: string | null, deviceId?: string | null, deviceName?: string | null, deviceTypes?: Array<string | null> | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, department?: Array<{ __typename?: 'Department', id?: string | null, name?: string | null } | null> | null } | null, error?: { __typename?: 'ErrorType', message: string, code: string } | null } | null };

export type UpdateResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<SpacesResourceInput>;
}>;


export type UpdateResourceMutation = { __typename?: 'Mutation', updateResource?: { __typename?: 'SpacesResourcePayload', error?: { __typename?: 'ErrorType', code: string, message: string } | null, resource?: { __typename?: 'SpacesResourceType', notes?: string | null, photo?: string | null, _id?: string | null } | null } | null };

export type UpdateSpaceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<SpacesInputType>;
}>;


export type UpdateSpaceMutation = { __typename?: 'Mutation', updateSpace?: { __typename?: 'SpacesPaylaod', spaces?: { __typename?: 'SpacesType', _id?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type UpdateSpaceCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<SpacesCategoryInputType>;
}>;


export type UpdateSpaceCategoryMutation = { __typename?: 'Mutation', updateSpaceCategory?: { __typename?: 'SpacesCategoryPayload', error?: { __typename?: 'ErrorType', code: string, message: string } | null, category?: { __typename?: 'SpacesCategoryType', _id?: string | null, name?: string | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UserPaylaod', error?: { __typename?: 'ErrorType', code: string, message: string } | null, user?: { __typename?: 'User', id?: string | null } | null } | null };

export type UpdateVisitorMutationVariables = Exact<{
  input?: InputMaybe<UpdateVisitorInput>;
}>;


export type UpdateVisitorMutation = { __typename?: 'Mutation', updateVisitor?: { __typename?: 'VisitorPaylaod', visitor?: { __typename?: 'Visitor', id?: string | null, img?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type VerifyOtpMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOtp?: { __typename?: 'UserPaylaod', token?: string | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null } | null, error?: { __typename?: 'ErrorType', code: string, message: string } | null } | null };

export type GetAgreementQueryVariables = Exact<{
  agreementId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAgreementQuery = { __typename?: 'Query', getAgreement?: { __typename?: 'AgreementType', _id?: string | null, title?: string | null, content?: string | null, updatedAt?: any | null, signatureType?: SignatureTypeEnum | null, requireSignature?: boolean | null } | null };

export type GetAgreementsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAgreementsQuery = { __typename?: 'Query', getAgreements?: Array<{ __typename?: 'AgreementType', _id?: string | null, title?: string | null, content?: string | null, updatedAt?: any | null, signatureType?: SignatureTypeEnum | null, requireSignature?: boolean | null } | null> | null };

export type GetArchivedEmployeesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArchivedEmployeesQuery = { __typename?: 'Query', getArchivedEmployees?: { __typename?: 'UserList', count?: number | null, user?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, email?: string | null, archivedAt?: any | null, lastName?: string | null, isArchived?: boolean | null } | null> | null } | null };

export type GetBookingSpacesQueryVariables = Exact<{
  space?: InputMaybe<Scalars['ID']['input']>;
  resource?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBookingSpacesQuery = { __typename?: 'Query', getBookingSpaces?: Array<{ __typename?: 'BookingSpaceType', start?: any | null, _id?: string | null, end?: any | null, category?: { __typename?: 'SpacesCategoryType', _id?: string | null, name?: string | null } | null, space?: { __typename?: 'SpacesType', _id?: string | null, name?: string | null } | null, resource?: { __typename?: 'SpacesResourceType', _id?: string | null, name?: string | null } | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, employee?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, img?: string | null } | null } | null> | null };

export type GetCategoriesQueryVariables = Exact<{
  location: Scalars['ID']['input'];
}>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories?: Array<{ __typename?: 'VisitorCategory', id?: string | null, name?: string | null, enabled?: boolean | null, approval?: boolean | null, host?: boolean | null, priority?: number | null, fields?: Array<{ __typename?: 'Field', id?: string | null, name?: string | null, label?: string | null, type?: string | null, enabled?: boolean | null, required?: boolean | null, priority?: number | null, clearResponseAfterEachVisit?: boolean | null } | null> | null } | null> | null };

export type GetCompanyDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyDetailsQuery = { __typename?: 'Query', getCompanyDetails?: { __typename?: 'Company', id?: string | null, name?: string | null } | null };

export type GetDeliveriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  collected?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<SortedInput>;
  location?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDeliveriesQuery = { __typename?: 'Query', getDeliveries?: { __typename?: 'DeliveryList', count?: number | null, delivery?: Array<{ __typename?: 'DeliveryType', id?: string | null, signature?: boolean | null, deliveryType?: string | null, note?: string | null, delivered?: any | null, collected?: boolean | null, collectedAt?: any | null, createdAt?: any | null, reciepient?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, img?: string | null } | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetDepartmentsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDepartmentsQuery = { __typename?: 'Query', getDepartments?: { __typename?: 'DepartmentList', count?: number | null, department?: Array<{ __typename?: 'Department', id?: string | null, name?: string | null, location?: { __typename?: 'OfficeLocation', name?: string | null, id?: string | null } | null, user?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null } | null> | null } | null> | null } | null };

export type GetDevicesQueryVariables = Exact<{
  location: Scalars['ID']['input'];
}>;


export type GetDevicesQuery = { __typename?: 'Query', getDevices?: Array<{ __typename?: 'Device', id?: string | null, deviceTypes?: Array<string | null> | null, deviceName?: string | null, deviceId?: string | null, department?: Array<{ __typename?: 'Department', name?: string | null, id?: string | null } | null> | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, categoryType?: Array<{ __typename?: 'VisitorCategory', name?: string | null, id?: string | null } | null> | null, visitorNotifications?: { __typename?: 'VisitorNotifications', checkInPending?: string | null, checkIn?: string | null, checkOut?: string | null } | null } | null> | null };

export type GetEmployeesTimelineQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<SortedInput>;
  location?: InputMaybe<Scalars['ID']['input']>;
  signedType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEmployeesTimelineQuery = { __typename?: 'Query', getEmployeesTimeline?: { __typename?: 'EmployeeTimelineList', count?: number | null, employee?: Array<{ __typename?: 'EmployeeTimeline', id?: string | null, signedIn?: string | null, signedOut?: string | null, signedInDevice?: string | null, signedOutDevice?: string | null, signedType?: string | null, statusMessage?: string | null, returnTime?: string | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, employee?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, img?: string | null, email?: string | null, id?: string | null } | null, signInQue?: Array<{ __typename?: 'SignInQue', answer?: string | null, label?: string | null, type?: string | null } | null> | null } | null> | null } | null };

export type GetFieldQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFieldQuery = { __typename?: 'Query', getField?: Array<{ __typename?: 'Field', id?: string | null, name?: string | null, label?: string | null, type?: string | null, enabled?: boolean | null, required?: boolean | null, clearResponseAfterEachVisit?: boolean | null } | null> | null };

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationsQuery = { __typename?: 'Query', getIntegrations?: { __typename?: 'IntegrationType', googleChat?: { __typename?: 'GoogleChatType', enabled?: boolean | null, webhooks?: Array<{ __typename?: 'HookType', name?: string | null, webhookUrl?: string | null } | null> | null } | null, msTeams?: { __typename?: 'MsTeamsType', teamId?: string | null, tenantId?: string | null, enabled?: boolean | null, channels?: Array<{ __typename?: 'MsTeamsChannelType', channelId?: string | null, channelName?: string | null } | null> | null } | null } | null };

export type GetOfficeLocationQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetOfficeLocationQuery = { __typename?: 'Query', getOfficeLocation?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null, address?: string | null, customHeading?: string | null, agreements?: Array<string | null> | null, visitorPhoto?: boolean | null, devices?: Array<{ __typename?: 'Device', id?: string | null, deviceName?: string | null } | null> | null, returningVisitors?: { __typename?: 'ReturningVisitorsType', saveDetails?: boolean | null, displayNameMatches?: boolean | null } | null, selectHost?: { __typename?: 'SelectHostType', showList?: boolean | null, requireVisitors?: boolean | null, displayHostStatus?: boolean | null, allowOnStaticQR?: boolean | null } | null, employees?: { __typename?: 'EmployeeSettings', generalSetting?: { __typename?: 'GeneralEmployeeSetting', workRemotely?: boolean | null, signOutTime?: string | null, updatePicture?: boolean | null, verifyPhoto?: boolean | null } | null, pocket?: { __typename?: 'EmployeePocket', signIn?: boolean | null, verifyEmployee?: string | null, preRegister?: boolean | null } | null, signInQue?: Array<{ __typename?: 'SignInQueueItem', label?: string | null, type?: string | null, required?: boolean | null, disabled?: boolean | null } | null> | null, signOutMsg?: { __typename?: 'SignOutMessage', required?: boolean | null, msgs?: Array<{ __typename?: 'msgType', required?: boolean | null, msg?: string | null, _id?: string | null } | null> | null } | null } | null, selectedAgreement?: { __typename?: 'SelectedAgreement', signature?: boolean | null, agreement?: string | null } | null, deliveries?: { __typename?: 'DeliveriesType', general?: { __typename?: 'GeneralDeliveryType', scanDelivery?: boolean | null, allowDelivery?: boolean | null, deliveryContact?: Array<{ __typename?: 'GeneralDeliveryContactType', name?: string | null, email?: string | null, phone?: string | null } | null> | null } | null, deliveryInst?: { __typename?: 'DeliveryInstType', recipientDelivery?: { __typename?: 'RecipientDeliveryType', noSignature?: string | null, signatureRquired?: string | null, recipientOut?: string | null } | null, generalDelivery?: { __typename?: 'GeneralDeliveryInstType', noSignature?: string | null, signatureRquired?: string | null } | null } | null } | null, savedImgs?: Array<{ __typename?: 'SavedImgsType', id?: string | null, enabled?: boolean | null, url?: string | null } | null> | null, contactLess?: { __typename?: 'ContactLess', enabled?: boolean | null, qrCode?: string | null, token?: string | null } | null, branding?: { __typename?: 'BrandingType', accentColor?: string | null, allowScanning?: boolean | null, badgeType?: string | null, displaysOn?: Array<string | null> | null, logo?: string | null } | null, signInNotifications?: { __typename?: 'SignInNotificationsType', enabled?: boolean | null, recipients?: Array<{ __typename?: 'SignInNotificationRecipient', email?: string | null, phone?: string | null } | null> | null } | null, visitorButton?: { __typename?: 'VisitorButton', buttonRadius?: string | null, buttonColor?: string | null, buttonBg?: string | null } | null, approvals?: { __typename?: 'ApprovalsType', allowHostsToApprove?: boolean | null, includeAllVisitorResponses?: boolean | null, sendApprovalAlerts?: { __typename?: 'SendApprovalAlertsType', enabled?: boolean | null, recipients?: Array<{ __typename?: 'ApprovalRecipient', phone?: string | null, email?: string | null } | null> | null } | null } | null, signOutSettings?: { __typename?: 'SignOutSettingsType', notifyOnSignOut?: boolean | null, autoSignOutTime?: { __typename?: 'AutoSignOutTimeType', enabled?: boolean | null, time?: string | null } | null, notifyIfNotSignedOut?: { __typename?: 'NotifyIfNotSignedOutType', enabled?: boolean | null, hours?: string | null } | null } | null } | null };

export type GetOfficeLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfficeLocationsQuery = { __typename?: 'Query', getOfficeLocations?: Array<{ __typename?: 'OfficeLocation', id?: string | null, name?: string | null, address?: string | null, customHeading?: string | null, agreements?: Array<string | null> | null, visitorPhoto?: boolean | null, devices?: Array<{ __typename?: 'Device', id?: string | null, deviceName?: string | null } | null> | null, returningVisitors?: { __typename?: 'ReturningVisitorsType', saveDetails?: boolean | null, displayNameMatches?: boolean | null } | null, selectHost?: { __typename?: 'SelectHostType', showList?: boolean | null, requireVisitors?: boolean | null, displayHostStatus?: boolean | null, allowOnStaticQR?: boolean | null } | null, employees?: { __typename?: 'EmployeeSettings', generalSetting?: { __typename?: 'GeneralEmployeeSetting', workRemotely?: boolean | null, signOutTime?: string | null, updatePicture?: boolean | null, verifyPhoto?: boolean | null } | null, pocket?: { __typename?: 'EmployeePocket', signIn?: boolean | null, verifyEmployee?: string | null, preRegister?: boolean | null } | null, signInQue?: Array<{ __typename?: 'SignInQueueItem', label?: string | null, type?: string | null, required?: boolean | null, disabled?: boolean | null, priority?: number | null } | null> | null, signOutMsg?: { __typename?: 'SignOutMessage', required?: boolean | null, msgs?: Array<{ __typename?: 'msgType', required?: boolean | null, msg?: string | null, _id?: string | null } | null> | null } | null } | null, selectedAgreement?: { __typename?: 'SelectedAgreement', signature?: boolean | null, agreement?: string | null } | null, deliveries?: { __typename?: 'DeliveriesType', general?: { __typename?: 'GeneralDeliveryType', scanDelivery?: boolean | null, allowDelivery?: boolean | null, deliveryContact?: Array<{ __typename?: 'GeneralDeliveryContactType', name?: string | null, email?: string | null, phone?: string | null } | null> | null } | null, deliveryInst?: { __typename?: 'DeliveryInstType', recipientDelivery?: { __typename?: 'RecipientDeliveryType', noSignature?: string | null, signatureRquired?: string | null, recipientOut?: string | null } | null, generalDelivery?: { __typename?: 'GeneralDeliveryInstType', noSignature?: string | null, signatureRquired?: string | null } | null } | null } | null, savedImgs?: Array<{ __typename?: 'SavedImgsType', id?: string | null, enabled?: boolean | null, url?: string | null } | null> | null, contactLess?: { __typename?: 'ContactLess', enabled?: boolean | null, qrCode?: string | null, token?: string | null } | null } | null> | null };

export type GetPreVisitorsQueryVariables = Exact<{
  company: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorted?: InputMaybe<SortedInput>;
  location: Scalars['ID']['input'];
}>;


export type GetPreVisitorsQuery = { __typename?: 'Query', getPreVisitors?: { __typename?: 'PreRegisterList', count?: number | null, visitors?: Array<{ __typename?: 'PreRegisterType', id?: string | null, endDate?: string | null, data?: any | null, createdAt?: string | null, startDate?: string | null, startTime?: string | null, visitorEmail?: string | null, message?: string | null, department?: { __typename?: 'Department', name?: string | null, id?: string | null } | null, employees?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null, category?: { __typename?: 'VisitorCategory', id?: string | null, name?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetResourceScheduleQueryVariables = Exact<{
  location: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  space?: InputMaybe<Scalars['ID']['input']>;
  resourceCategory?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetResourceScheduleQuery = { __typename?: 'Query', getResourceSchedule?: Array<{ __typename?: 'ResourceSchedule', _id?: string | null, categoryName?: string | null, resourceName?: string | null, bookings?: Array<{ __typename?: 'SimpleBookingTime', end?: any | null, start?: any | null } | null> | null } | null> | null };

export type GetSpacesQueryVariables = Exact<{
  location: Scalars['ID']['input'];
  space?: InputMaybe<Scalars['ID']['input']>;
  resourceCategory?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSpacesQuery = { __typename?: 'Query', getSpaces?: Array<{ __typename?: 'SpacesType', name?: string | null, _id?: string | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, resource?: Array<{ __typename?: 'SpacesResourceType', name?: string | null, _id?: string | null } | null> | null } | null> | null };

export type GetSpaceCategoriesQueryVariables = Exact<{
  location: Scalars['ID']['input'];
}>;


export type GetSpaceCategoriesQuery = { __typename?: 'Query', getSpaceCategories?: Array<{ __typename?: 'SpacesCategoryType', _id?: string | null, icon?: string | null, name?: string | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, resources?: Array<{ __typename?: 'SpacesResourceType', name?: string | null, _id?: string | null } | null> | null } | null> | null };

export type GetSpaceResourceQueryVariables = Exact<{
  location: Scalars['ID']['input'];
  features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  resourceCategory?: InputMaybe<Scalars['ID']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSpaceResourceQuery = { __typename?: 'Query', getSpaceResource?: Array<{ __typename?: 'SpacesResourceType', _id?: string | null, capacity?: number | null, name?: string | null, notes?: string | null, photo?: string | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, resourceCategory?: { __typename?: 'SpacesCategoryType', _id?: string | null, name?: string | null } | null, space?: { __typename?: 'SpacesType', _id?: string | null, name?: string | null } | null } | null> | null };

export type GetUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorted?: InputMaybe<SortedInput>;
  location?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<RoleEnum>;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers?: { __typename?: 'UserList', count?: number | null, user?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, img?: string | null, email?: string | null, createdAt?: any | null, role?: RoleEnum | null, phone?: string | null, updatedAt?: any | null, lastName?: string | null, notificationPreference?: Array<string | null> | null, workingRemote?: string | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, company?: { __typename?: 'Company', name?: string | null, id?: string | null } | null, department?: { __typename?: 'Department', id?: string | null, name?: string | null } | null, timeline?: { __typename?: 'EmployeeTimeline', id?: string | null, signedIn?: string | null, returnTime?: string | null, signedOut?: string | null, signedType?: string | null, statusMessage?: string | null } | null } | null> | null } | null };

export type GetVistorsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  remembered?: InputMaybe<Scalars['Boolean']['input']>;
  sorted?: InputMaybe<SortedInput>;
  location?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVistorsQuery = { __typename?: 'Query', getVistors?: { __typename?: 'VisitorList', count?: number | null, visitor?: Array<{ __typename?: 'Visitor', id?: string | null, img?: string | null, signedType?: string | null, signedInDevice?: string | null, signedOutDevice?: string | null, anonymize?: boolean | null, data?: any | null, signedIn?: any | null, signedOut?: any | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, department?: { __typename?: 'Department', name?: string | null, id?: string | null } | null, category?: { __typename?: 'VisitorCategory', id?: string | null, name?: string | null } | null, employees?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null, selectedAgreement?: { __typename?: 'VisitorAgreement', agreement?: string | null, signatureImg?: string | null } | null } | null> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id?: string | null, firstName?: string | null, img?: string | null, email?: string | null, createdAt?: any | null, role?: RoleEnum | null, phone?: string | null, updatedAt?: any | null, lastName?: string | null, notificationPreference?: Array<string | null> | null, workingRemote?: string | null, location?: { __typename?: 'OfficeLocation', id?: string | null, name?: string | null } | null, company?: { __typename?: 'Company', name?: string | null, id?: string | null } | null, department?: { __typename?: 'Department', id?: string | null, name?: string | null } | null, timeline?: { __typename?: 'EmployeeTimeline', id?: string | null, signedIn?: string | null, returnTime?: string | null, signedOut?: string | null, signedType?: string | null, statusMessage?: string | null } | null } | null };


export const CreateAgreementDocument = gql`
    mutation CreateAgreement($content: String!, $createAgreementId: String, $title: String!, $signatureType: SignatureTypeEnum, $requireSignature: Boolean) {
  createAgreement(content: $content, id: $createAgreementId, title: $title, signatureType: $signatureType, requireSignature: $requireSignature) {
    _id
    title
    content
    signatureType
    requireSignature
  }
}
    `;
export type CreateAgreementMutationFn = Apollo.MutationFunction<CreateAgreementMutation, CreateAgreementMutationVariables>;

/**
 * __useCreateAgreementMutation__
 *
 * To run a mutation, you first call `useCreateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgreementMutation, { data, loading, error }] = useCreateAgreementMutation({
 *   variables: {
 *      content: // value for 'content'
 *      createAgreementId: // value for 'createAgreementId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgreementMutation, CreateAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgreementMutation, CreateAgreementMutationVariables>(CreateAgreementDocument, options);
      }
export type CreateAgreementMutationHookResult = ReturnType<typeof useCreateAgreementMutation>;
export type CreateAgreementMutationResult = Apollo.MutationResult<CreateAgreementMutation>;
export type CreateAgreementMutationOptions = Apollo.BaseMutationOptions<CreateAgreementMutation, CreateAgreementMutationVariables>;
export const AddBookingSpaceDocument = gql`
    mutation AddBookingSpace($input: BookingSpaceInput) {
  addBookingSpace(input: $input) {
    error {
      code
      message
    }
    booking {
      _id
    }
  }
}
    `;
export type AddBookingSpaceMutationFn = Apollo.MutationFunction<AddBookingSpaceMutation, AddBookingSpaceMutationVariables>;

/**
 * __useAddBookingSpaceMutation__
 *
 * To run a mutation, you first call `useAddBookingSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBookingSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBookingSpaceMutation, { data, loading, error }] = useAddBookingSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBookingSpaceMutation(baseOptions?: Apollo.MutationHookOptions<AddBookingSpaceMutation, AddBookingSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBookingSpaceMutation, AddBookingSpaceMutationVariables>(AddBookingSpaceDocument, options);
      }
export type AddBookingSpaceMutationHookResult = ReturnType<typeof useAddBookingSpaceMutation>;
export type AddBookingSpaceMutationResult = Apollo.MutationResult<AddBookingSpaceMutation>;
export type AddBookingSpaceMutationOptions = Apollo.BaseMutationOptions<AddBookingSpaceMutation, AddBookingSpaceMutationVariables>;
export const AddLocationDocument = gql`
    mutation AddLocation($name: String, $address: String, $id: ID) {
  addLocation(name: $name, address: $address, _id: $id) {
    location {
      id
      name
    }
  }
}
    `;
export type AddLocationMutationFn = Apollo.MutationFunction<AddLocationMutation, AddLocationMutationVariables>;

/**
 * __useAddLocationMutation__
 *
 * To run a mutation, you first call `useAddLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationMutation, { data, loading, error }] = useAddLocationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationMutation, AddLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationMutation, AddLocationMutationVariables>(AddLocationDocument, options);
      }
export type AddLocationMutationHookResult = ReturnType<typeof useAddLocationMutation>;
export type AddLocationMutationResult = Apollo.MutationResult<AddLocationMutation>;
export type AddLocationMutationOptions = Apollo.BaseMutationOptions<AddLocationMutation, AddLocationMutationVariables>;
export const AddResourcesDocument = gql`
    mutation AddResources($input: SpacesResourceInput) {
  addResources(input: $input) {
    error {
      code
      message
    }
    resource {
      name
      _id
    }
  }
}
    `;
export type AddResourcesMutationFn = Apollo.MutationFunction<AddResourcesMutation, AddResourcesMutationVariables>;

/**
 * __useAddResourcesMutation__
 *
 * To run a mutation, you first call `useAddResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResourcesMutation, { data, loading, error }] = useAddResourcesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResourcesMutation(baseOptions?: Apollo.MutationHookOptions<AddResourcesMutation, AddResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResourcesMutation, AddResourcesMutationVariables>(AddResourcesDocument, options);
      }
export type AddResourcesMutationHookResult = ReturnType<typeof useAddResourcesMutation>;
export type AddResourcesMutationResult = Apollo.MutationResult<AddResourcesMutation>;
export type AddResourcesMutationOptions = Apollo.BaseMutationOptions<AddResourcesMutation, AddResourcesMutationVariables>;
export const AddSpacesDocument = gql`
    mutation AddSpaces($input: SpacesInputType) {
  addSpaces(input: $input) {
    error {
      code
      message
    }
    spaces {
      name
      _id
      location {
        id
        name
      }
      resource {
        name
        _id
      }
    }
  }
}
    `;
export type AddSpacesMutationFn = Apollo.MutationFunction<AddSpacesMutation, AddSpacesMutationVariables>;

/**
 * __useAddSpacesMutation__
 *
 * To run a mutation, you first call `useAddSpacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpacesMutation, { data, loading, error }] = useAddSpacesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSpacesMutation(baseOptions?: Apollo.MutationHookOptions<AddSpacesMutation, AddSpacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSpacesMutation, AddSpacesMutationVariables>(AddSpacesDocument, options);
      }
export type AddSpacesMutationHookResult = ReturnType<typeof useAddSpacesMutation>;
export type AddSpacesMutationResult = Apollo.MutationResult<AddSpacesMutation>;
export type AddSpacesMutationOptions = Apollo.BaseMutationOptions<AddSpacesMutation, AddSpacesMutationVariables>;
export const AddSpaceCategoryDocument = gql`
    mutation AddSpaceCategory($input: SpacesCategoryInputType) {
  addSpaceCategory(input: $input) {
    error {
      code
      message
    }
    category {
      _id
      name
    }
  }
}
    `;
export type AddSpaceCategoryMutationFn = Apollo.MutationFunction<AddSpaceCategoryMutation, AddSpaceCategoryMutationVariables>;

/**
 * __useAddSpaceCategoryMutation__
 *
 * To run a mutation, you first call `useAddSpaceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpaceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpaceCategoryMutation, { data, loading, error }] = useAddSpaceCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSpaceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddSpaceCategoryMutation, AddSpaceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSpaceCategoryMutation, AddSpaceCategoryMutationVariables>(AddSpaceCategoryDocument, options);
      }
export type AddSpaceCategoryMutationHookResult = ReturnType<typeof useAddSpaceCategoryMutation>;
export type AddSpaceCategoryMutationResult = Apollo.MutationResult<AddSpaceCategoryMutation>;
export type AddSpaceCategoryMutationOptions = Apollo.BaseMutationOptions<AddSpaceCategoryMutation, AddSpaceCategoryMutationVariables>;
export const AddTabImgDocument = gql`
    mutation AddTabImg($url: String, $locationId: ID!) {
  addTabImg(url: $url, locationId: $locationId)
}
    `;
export type AddTabImgMutationFn = Apollo.MutationFunction<AddTabImgMutation, AddTabImgMutationVariables>;

/**
 * __useAddTabImgMutation__
 *
 * To run a mutation, you first call `useAddTabImgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTabImgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTabImgMutation, { data, loading, error }] = useAddTabImgMutation({
 *   variables: {
 *      url: // value for 'url'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useAddTabImgMutation(baseOptions?: Apollo.MutationHookOptions<AddTabImgMutation, AddTabImgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTabImgMutation, AddTabImgMutationVariables>(AddTabImgDocument, options);
      }
export type AddTabImgMutationHookResult = ReturnType<typeof useAddTabImgMutation>;
export type AddTabImgMutationResult = Apollo.MutationResult<AddTabImgMutation>;
export type AddTabImgMutationOptions = Apollo.BaseMutationOptions<AddTabImgMutation, AddTabImgMutationVariables>;
export const AuthLoginDocument = gql`
    mutation AuthLogin($email: String, $password: String) {
  authLogin(email: $email, password: $password) {
    user {
      id
      email
      role
      phone
      createdAt
      updatedAt
    }
    error {
      message
      code
    }
    token
  }
}
    `;
export type AuthLoginMutationFn = Apollo.MutationFunction<AuthLoginMutation, AuthLoginMutationVariables>;

/**
 * __useAuthLoginMutation__
 *
 * To run a mutation, you first call `useAuthLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginMutation, { data, loading, error }] = useAuthLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthLoginMutation(baseOptions?: Apollo.MutationHookOptions<AuthLoginMutation, AuthLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLoginMutation, AuthLoginMutationVariables>(AuthLoginDocument, options);
      }
export type AuthLoginMutationHookResult = ReturnType<typeof useAuthLoginMutation>;
export type AuthLoginMutationResult = Apollo.MutationResult<AuthLoginMutation>;
export type AuthLoginMutationOptions = Apollo.BaseMutationOptions<AuthLoginMutation, AuthLoginMutationVariables>;
export const CreateBulkUsersDocument = gql`
    mutation CreateBulkUsers($input: [UserInput]) {
  createBulkUsers(input: $input) {
    count
    user {
      id
      firstName
    }
  }
}
    `;
export type CreateBulkUsersMutationFn = Apollo.MutationFunction<CreateBulkUsersMutation, CreateBulkUsersMutationVariables>;

/**
 * __useCreateBulkUsersMutation__
 *
 * To run a mutation, you first call `useCreateBulkUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkUsersMutation, { data, loading, error }] = useCreateBulkUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkUsersMutation, CreateBulkUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkUsersMutation, CreateBulkUsersMutationVariables>(CreateBulkUsersDocument, options);
      }
export type CreateBulkUsersMutationHookResult = ReturnType<typeof useCreateBulkUsersMutation>;
export type CreateBulkUsersMutationResult = Apollo.MutationResult<CreateBulkUsersMutation>;
export type CreateBulkUsersMutationOptions = Apollo.BaseMutationOptions<CreateBulkUsersMutation, CreateBulkUsersMutationVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($input: CategoryInput) {
  createCategory(input: $input) {
    category {
      id
      name
      fields {
        name
        label
        type
        enabled
      }
    }
    error {
      message
      code
    }
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const CreateDeliveryDocument = gql`
    mutation CreateDelivery($input: DeliveryInput) {
  createDelivery(input: $input) {
    error {
      code
      message
    }
    delivery {
      id
    }
  }
}
    `;
export type CreateDeliveryMutationFn = Apollo.MutationFunction<CreateDeliveryMutation, CreateDeliveryMutationVariables>;

/**
 * __useCreateDeliveryMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryMutation, { data, loading, error }] = useCreateDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryMutation, CreateDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryMutation, CreateDeliveryMutationVariables>(CreateDeliveryDocument, options);
      }
export type CreateDeliveryMutationHookResult = ReturnType<typeof useCreateDeliveryMutation>;
export type CreateDeliveryMutationResult = Apollo.MutationResult<CreateDeliveryMutation>;
export type CreateDeliveryMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryMutation, CreateDeliveryMutationVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($input: DepartmentInput) {
  createDepartment(input: $input) {
    department {
      id
      name
      user {
        id
        firstName
        lastName
        email
        phone
        role
      }
    }
    error {
      message
      code
    }
  }
}
    `;
export type CreateDepartmentMutationFn = Apollo.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
      }
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = Apollo.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const CreateDeviceDocument = gql`
    mutation CreateDevice($input: DeviceInput) {
  createDevice(input: $input) {
    error {
      code
      message
    }
    device {
      id
      deviceName
      deviceId
    }
  }
}
    `;
export type CreateDeviceMutationFn = Apollo.MutationFunction<CreateDeviceMutation, CreateDeviceMutationVariables>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceMutation, CreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument, options);
      }
export type CreateDeviceMutationHookResult = ReturnType<typeof useCreateDeviceMutation>;
export type CreateDeviceMutationResult = Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const CreatePreRegisterDocument = gql`
    mutation CreatePreRegister($input: PreRegisterInput) {
  createPreRegister(input: $input) {
    visitor {
      id
      data
    }
    error {
      code
      message
    }
  }
}
    `;
export type CreatePreRegisterMutationFn = Apollo.MutationFunction<CreatePreRegisterMutation, CreatePreRegisterMutationVariables>;

/**
 * __useCreatePreRegisterMutation__
 *
 * To run a mutation, you first call `useCreatePreRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreRegisterMutation, { data, loading, error }] = useCreatePreRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreRegisterMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreRegisterMutation, CreatePreRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreRegisterMutation, CreatePreRegisterMutationVariables>(CreatePreRegisterDocument, options);
      }
export type CreatePreRegisterMutationHookResult = ReturnType<typeof useCreatePreRegisterMutation>;
export type CreatePreRegisterMutationResult = Apollo.MutationResult<CreatePreRegisterMutation>;
export type CreatePreRegisterMutationOptions = Apollo.BaseMutationOptions<CreatePreRegisterMutation, CreatePreRegisterMutationVariables>;
export const CreatedEmployeeTimelineDeviceDocument = gql`
    mutation CreatedEmployeeTimelineDevice($input: EmployeeTimelineDeviceInput) {
  createdEmployeeTimelineDevice(input: $input) {
    error {
      code
      message
    }
    employee {
      id
    }
  }
}
    `;
export type CreatedEmployeeTimelineDeviceMutationFn = Apollo.MutationFunction<CreatedEmployeeTimelineDeviceMutation, CreatedEmployeeTimelineDeviceMutationVariables>;

/**
 * __useCreatedEmployeeTimelineDeviceMutation__
 *
 * To run a mutation, you first call `useCreatedEmployeeTimelineDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatedEmployeeTimelineDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createdEmployeeTimelineDeviceMutation, { data, loading, error }] = useCreatedEmployeeTimelineDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatedEmployeeTimelineDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreatedEmployeeTimelineDeviceMutation, CreatedEmployeeTimelineDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatedEmployeeTimelineDeviceMutation, CreatedEmployeeTimelineDeviceMutationVariables>(CreatedEmployeeTimelineDeviceDocument, options);
      }
export type CreatedEmployeeTimelineDeviceMutationHookResult = ReturnType<typeof useCreatedEmployeeTimelineDeviceMutation>;
export type CreatedEmployeeTimelineDeviceMutationResult = Apollo.MutationResult<CreatedEmployeeTimelineDeviceMutation>;
export type CreatedEmployeeTimelineDeviceMutationOptions = Apollo.BaseMutationOptions<CreatedEmployeeTimelineDeviceMutation, CreatedEmployeeTimelineDeviceMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: UserInput) {
  createUser(input: $input) {
    user {
      id
    }
    error {
      code
      message
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateVisitorDocument = gql`
    mutation CreateVisitor($input: VisitorInput) {
  createVisitor(input: $input) {
    visitor {
      id
    }
    error {
      code
      message
    }
  }
}
    `;
export type CreateVisitorMutationFn = Apollo.MutationFunction<CreateVisitorMutation, CreateVisitorMutationVariables>;

/**
 * __useCreateVisitorMutation__
 *
 * To run a mutation, you first call `useCreateVisitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitorMutation, { data, loading, error }] = useCreateVisitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVisitorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitorMutation, CreateVisitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitorMutation, CreateVisitorMutationVariables>(CreateVisitorDocument, options);
      }
export type CreateVisitorMutationHookResult = ReturnType<typeof useCreateVisitorMutation>;
export type CreateVisitorMutationResult = Apollo.MutationResult<CreateVisitorMutation>;
export type CreateVisitorMutationOptions = Apollo.BaseMutationOptions<CreateVisitorMutation, CreateVisitorMutationVariables>;
export const DeleteAgreementDocument = gql`
    mutation DeleteAgreement($deleteAgreementId: String!) {
  deleteAgreement(id: $deleteAgreementId)
}
    `;
export type DeleteAgreementMutationFn = Apollo.MutationFunction<DeleteAgreementMutation, DeleteAgreementMutationVariables>;

/**
 * __useDeleteAgreementMutation__
 *
 * To run a mutation, you first call `useDeleteAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgreementMutation, { data, loading, error }] = useDeleteAgreementMutation({
 *   variables: {
 *      deleteAgreementId: // value for 'deleteAgreementId'
 *   },
 * });
 */
export function useDeleteAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgreementMutation, DeleteAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgreementMutation, DeleteAgreementMutationVariables>(DeleteAgreementDocument, options);
      }
export type DeleteAgreementMutationHookResult = ReturnType<typeof useDeleteAgreementMutation>;
export type DeleteAgreementMutationResult = Apollo.MutationResult<DeleteAgreementMutation>;
export type DeleteAgreementMutationOptions = Apollo.BaseMutationOptions<DeleteAgreementMutation, DeleteAgreementMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($categoryId: ID) {
  deleteCategory(categoryId: $categoryId)
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const DeleteDeliveryDocument = gql`
    mutation DeleteDelivery($id: String) {
  deleteDelivery(_id: $id)
}
    `;
export type DeleteDeliveryMutationFn = Apollo.MutationFunction<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>;

/**
 * __useDeleteDeliveryMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryMutation, { data, loading, error }] = useDeleteDeliveryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>(DeleteDeliveryDocument, options);
      }
export type DeleteDeliveryMutationHookResult = ReturnType<typeof useDeleteDeliveryMutation>;
export type DeleteDeliveryMutationResult = Apollo.MutationResult<DeleteDeliveryMutation>;
export type DeleteDeliveryMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($departmentId: ID) {
  deleteDepartment(departmentId: $departmentId)
}
    `;
export type DeleteDepartmentMutationFn = Apollo.MutationFunction<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentMutation, { data, loading, error }] = useDeleteDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, options);
      }
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationResult = Apollo.MutationResult<DeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = Apollo.BaseMutationOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;
export const DeleteDeviceDocument = gql`
    mutation DeleteDevice($deleteDeviceId: ID!) {
  deleteDevice(id: $deleteDeviceId) {
    device {
      id
      deviceName
    }
    error {
      code
      message
    }
  }
}
    `;
export type DeleteDeviceMutationFn = Apollo.MutationFunction<DeleteDeviceMutation, DeleteDeviceMutationVariables>;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      deleteDeviceId: // value for 'deleteDeviceId'
 *   },
 * });
 */
export function useDeleteDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(DeleteDeviceDocument, options);
      }
export type DeleteDeviceMutationHookResult = ReturnType<typeof useDeleteDeviceMutation>;
export type DeleteDeviceMutationResult = Apollo.MutationResult<DeleteDeviceMutation>;
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($employeeId: ID) {
  deleteEmployee(employeeId: $employeeId) {
    user {
      id
    }
    error {
      code
      message
    }
  }
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const DeleteFieldDocument = gql`
    mutation DeleteField($categoryId: ID, $fieldId: ID) {
  deleteField(categoryId: $categoryId, fieldId: $fieldId)
}
    `;
export type DeleteFieldMutationFn = Apollo.MutationFunction<DeleteFieldMutation, DeleteFieldMutationVariables>;

/**
 * __useDeleteFieldMutation__
 *
 * To run a mutation, you first call `useDeleteFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFieldMutation, { data, loading, error }] = useDeleteFieldMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useDeleteFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFieldMutation, DeleteFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFieldMutation, DeleteFieldMutationVariables>(DeleteFieldDocument, options);
      }
export type DeleteFieldMutationHookResult = ReturnType<typeof useDeleteFieldMutation>;
export type DeleteFieldMutationResult = Apollo.MutationResult<DeleteFieldMutation>;
export type DeleteFieldMutationOptions = Apollo.BaseMutationOptions<DeleteFieldMutation, DeleteFieldMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($locationId: ID!) {
  deleteLocation(locationId: $locationId) {
    error {
      code
      message
    }
    location {
      id
    }
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const DeletePreRegisterDocument = gql`
    mutation DeletePreRegister($deletePreRegisterId: ID!) {
  deletePreRegister(id: $deletePreRegisterId) {
    error {
      message
      code
    }
    visitor {
      id
    }
  }
}
    `;
export type DeletePreRegisterMutationFn = Apollo.MutationFunction<DeletePreRegisterMutation, DeletePreRegisterMutationVariables>;

/**
 * __useDeletePreRegisterMutation__
 *
 * To run a mutation, you first call `useDeletePreRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreRegisterMutation, { data, loading, error }] = useDeletePreRegisterMutation({
 *   variables: {
 *      deletePreRegisterId: // value for 'deletePreRegisterId'
 *   },
 * });
 */
export function useDeletePreRegisterMutation(baseOptions?: Apollo.MutationHookOptions<DeletePreRegisterMutation, DeletePreRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePreRegisterMutation, DeletePreRegisterMutationVariables>(DeletePreRegisterDocument, options);
      }
export type DeletePreRegisterMutationHookResult = ReturnType<typeof useDeletePreRegisterMutation>;
export type DeletePreRegisterMutationResult = Apollo.MutationResult<DeletePreRegisterMutation>;
export type DeletePreRegisterMutationOptions = Apollo.BaseMutationOptions<DeletePreRegisterMutation, DeletePreRegisterMutationVariables>;
export const RemoveIntegrationDocument = gql`
    mutation RemoveIntegration($webhookId: ID, $name: String) {
  removeIntegration(webhookId: $webhookId, name: $name) {
    googleChat {
      webhooks {
        name
        webhookUrl
      }
      enabled
    }
    msTeams {
      teamId
      channels {
        channelId
        channelName
      }
      tenantId
      enabled
    }
  }
}
    `;
export type RemoveIntegrationMutationFn = Apollo.MutationFunction<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>;

/**
 * __useRemoveIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationMutation, { data, loading, error }] = useRemoveIntegrationMutation({
 *   variables: {
 *      webhookId: // value for 'webhookId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRemoveIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>(RemoveIntegrationDocument, options);
      }
export type RemoveIntegrationMutationHookResult = ReturnType<typeof useRemoveIntegrationMutation>;
export type RemoveIntegrationMutationResult = Apollo.MutationResult<RemoveIntegrationMutation>;
export type RemoveIntegrationMutationOptions = Apollo.BaseMutationOptions<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>;
export const RemoveMsTeamsIntegrationDocument = gql`
    mutation RemoveMsTeamsIntegration {
  removeMsTeamsIntegration {
    googleChat {
      webhooks {
        name
        webhookUrl
      }
      enabled
    }
    msTeams {
      teamId
      channels {
        channelId
        channelName
      }
      tenantId
      enabled
    }
  }
}
    `;
export type RemoveMsTeamsIntegrationMutationFn = Apollo.MutationFunction<RemoveMsTeamsIntegrationMutation, RemoveMsTeamsIntegrationMutationVariables>;

/**
 * __useRemoveMsTeamsIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveMsTeamsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMsTeamsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMsTeamsIntegrationMutation, { data, loading, error }] = useRemoveMsTeamsIntegrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveMsTeamsIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMsTeamsIntegrationMutation, RemoveMsTeamsIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMsTeamsIntegrationMutation, RemoveMsTeamsIntegrationMutationVariables>(RemoveMsTeamsIntegrationDocument, options);
      }
export type RemoveMsTeamsIntegrationMutationHookResult = ReturnType<typeof useRemoveMsTeamsIntegrationMutation>;
export type RemoveMsTeamsIntegrationMutationResult = Apollo.MutationResult<RemoveMsTeamsIntegrationMutation>;
export type RemoveMsTeamsIntegrationMutationOptions = Apollo.BaseMutationOptions<RemoveMsTeamsIntegrationMutation, RemoveMsTeamsIntegrationMutationVariables>;
export const ReorderCategoriesDocument = gql`
    mutation ReorderCategories($items: [ReorderItemInput]!) {
  reorderCategories(items: $items)
}
    `;
export type ReorderCategoriesMutationFn = Apollo.MutationFunction<ReorderCategoriesMutation, ReorderCategoriesMutationVariables>;

/**
 * __useReorderCategoriesMutation__
 *
 * To run a mutation, you first call `useReorderCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCategoriesMutation, { data, loading, error }] = useReorderCategoriesMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useReorderCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderCategoriesMutation, ReorderCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCategoriesMutation, ReorderCategoriesMutationVariables>(ReorderCategoriesDocument, options);
      }
export type ReorderCategoriesMutationHookResult = ReturnType<typeof useReorderCategoriesMutation>;
export type ReorderCategoriesMutationResult = Apollo.MutationResult<ReorderCategoriesMutation>;
export type ReorderCategoriesMutationOptions = Apollo.BaseMutationOptions<ReorderCategoriesMutation, ReorderCategoriesMutationVariables>;
export const ReorderFieldsDocument = gql`
    mutation ReorderFields($categoryId: ID!, $items: [ReorderItemInput]!) {
  reorderFields(categoryId: $categoryId, items: $items)
}
    `;
export type ReorderFieldsMutationFn = Apollo.MutationFunction<ReorderFieldsMutation, ReorderFieldsMutationVariables>;

/**
 * __useReorderFieldsMutation__
 *
 * To run a mutation, you first call `useReorderFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFieldsMutation, { data, loading, error }] = useReorderFieldsMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useReorderFieldsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderFieldsMutation, ReorderFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderFieldsMutation, ReorderFieldsMutationVariables>(ReorderFieldsDocument, options);
      }
export type ReorderFieldsMutationHookResult = ReturnType<typeof useReorderFieldsMutation>;
export type ReorderFieldsMutationResult = Apollo.MutationResult<ReorderFieldsMutation>;
export type ReorderFieldsMutationOptions = Apollo.BaseMutationOptions<ReorderFieldsMutation, ReorderFieldsMutationVariables>;
export const GenerateResetOtpDocument = gql`
    mutation GenerateResetOtp($email: String) {
  generateResetOtp(email: $email) {
    token
    error {
      message
      code
    }
    user {
      firstName
      id
    }
  }
}
    `;
export type GenerateResetOtpMutationFn = Apollo.MutationFunction<GenerateResetOtpMutation, GenerateResetOtpMutationVariables>;

/**
 * __useGenerateResetOtpMutation__
 *
 * To run a mutation, you first call `useGenerateResetOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateResetOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateResetOtpMutation, { data, loading, error }] = useGenerateResetOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGenerateResetOtpMutation(baseOptions?: Apollo.MutationHookOptions<GenerateResetOtpMutation, GenerateResetOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateResetOtpMutation, GenerateResetOtpMutationVariables>(GenerateResetOtpDocument, options);
      }
export type GenerateResetOtpMutationHookResult = ReturnType<typeof useGenerateResetOtpMutation>;
export type GenerateResetOtpMutationResult = Apollo.MutationResult<GenerateResetOtpMutation>;
export type GenerateResetOtpMutationOptions = Apollo.BaseMutationOptions<GenerateResetOtpMutation, GenerateResetOtpMutationVariables>;
export const ResetPaswordDocument = gql`
    mutation ResetPasword($email: String, $password: String) {
  resetPasword(email: $email, password: $password) {
    token
    error {
      code
      message
    }
    user {
      id
      firstName
    }
  }
}
    `;
export type ResetPaswordMutationFn = Apollo.MutationFunction<ResetPaswordMutation, ResetPaswordMutationVariables>;

/**
 * __useResetPaswordMutation__
 *
 * To run a mutation, you first call `useResetPaswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPaswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPaswordMutation, { data, loading, error }] = useResetPaswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPaswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPaswordMutation, ResetPaswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPaswordMutation, ResetPaswordMutationVariables>(ResetPaswordDocument, options);
      }
export type ResetPaswordMutationHookResult = ReturnType<typeof useResetPaswordMutation>;
export type ResetPaswordMutationResult = Apollo.MutationResult<ResetPaswordMutation>;
export type ResetPaswordMutationOptions = Apollo.BaseMutationOptions<ResetPaswordMutation, ResetPaswordMutationVariables>;
export const RestoreEmployeeDocument = gql`
    mutation RestoreEmployee($employeeId: ID) {
  restoreEmployee(employeeId: $employeeId) {
    user {
      id
    }
    error {
      code
      message
    }
  }
}
    `;
export type RestoreEmployeeMutationFn = Apollo.MutationFunction<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>;

/**
 * __useRestoreEmployeeMutation__
 *
 * To run a mutation, you first call `useRestoreEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEmployeeMutation, { data, loading, error }] = useRestoreEmployeeMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useRestoreEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>(RestoreEmployeeDocument, options);
      }
export type RestoreEmployeeMutationHookResult = ReturnType<typeof useRestoreEmployeeMutation>;
export type RestoreEmployeeMutationResult = Apollo.MutationResult<RestoreEmployeeMutation>;
export type RestoreEmployeeMutationOptions = Apollo.BaseMutationOptions<RestoreEmployeeMutation, RestoreEmployeeMutationVariables>;
export const SaveMsTeamsChannelDocument = gql`
    mutation SaveMsTeamsChannel($teamId: String!, $channels: [MsTeamsChannelInput]!) {
  saveMsTeamsChannel(teamId: $teamId, channels: $channels) {
    googleChat {
      webhooks {
        name
        webhookUrl
      }
      enabled
    }
    msTeams {
      teamId
      channels {
        channelId
        channelName
      }
      tenantId
      enabled
    }
  }
}
    `;
export type SaveMsTeamsChannelMutationFn = Apollo.MutationFunction<SaveMsTeamsChannelMutation, SaveMsTeamsChannelMutationVariables>;

/**
 * __useSaveMsTeamsChannelMutation__
 *
 * To run a mutation, you first call `useSaveMsTeamsChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMsTeamsChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMsTeamsChannelMutation, { data, loading, error }] = useSaveMsTeamsChannelMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      channels: // value for 'channels'
 *   },
 * });
 */
export function useSaveMsTeamsChannelMutation(baseOptions?: Apollo.MutationHookOptions<SaveMsTeamsChannelMutation, SaveMsTeamsChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMsTeamsChannelMutation, SaveMsTeamsChannelMutationVariables>(SaveMsTeamsChannelDocument, options);
      }
export type SaveMsTeamsChannelMutationHookResult = ReturnType<typeof useSaveMsTeamsChannelMutation>;
export type SaveMsTeamsChannelMutationResult = Apollo.MutationResult<SaveMsTeamsChannelMutation>;
export type SaveMsTeamsChannelMutationOptions = Apollo.BaseMutationOptions<SaveMsTeamsChannelMutation, SaveMsTeamsChannelMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($input: SignUpInputType) {
  signup(input: $input) {
    user {
      phone
      firstName
      id
      role
    }
    token
    error {
      code
      message
    }
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const UpdateFieldDocument = gql`
    mutation UpdateField($categoryId: ID, $fieldId: ID, $required: Boolean, $enabled: Boolean, $clearResponseAfterEachVisit: Boolean) {
  updateField(
    categoryId: $categoryId
    fieldId: $fieldId
    required: $required
    enabled: $enabled
    clearResponseAfterEachVisit: $clearResponseAfterEachVisit
  )
}
    `;
export type UpdateFieldMutationFn = Apollo.MutationFunction<UpdateFieldMutation, UpdateFieldMutationVariables>;

/**
 * __useUpdateFieldMutation__
 *
 * To run a mutation, you first call `useUpdateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldMutation, { data, loading, error }] = useUpdateFieldMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      fieldId: // value for 'fieldId'
 *      required: // value for 'required'
 *      enabled: // value for 'enabled'
 *      clearResponseAfterEachVisit: // value for 'clearResponseAfterEachVisit'
 *   },
 * });
 */
export function useUpdateFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldMutation, UpdateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldMutation, UpdateFieldMutationVariables>(UpdateFieldDocument, options);
      }
export type UpdateFieldMutationHookResult = ReturnType<typeof useUpdateFieldMutation>;
export type UpdateFieldMutationResult = Apollo.MutationResult<UpdateFieldMutation>;
export type UpdateFieldMutationOptions = Apollo.BaseMutationOptions<UpdateFieldMutation, UpdateFieldMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($input: UpdateCategoryInput) {
  updateCategory(input: $input) {
    category {
      id
      name
      fields {
        name
        label
        type
        enabled
      }
    }
    error {
      message
      code
    }
  }
}
    `;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($input: UpdateCompanyInput) {
  updateCompany(input: $input)
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyImgsDocument = gql`
    mutation UpdateCompanyImgs($locationId: ID!, $imgs: [TabImgInput]) {
  updateCompanyImgs(locationId: $locationId, imgs: $imgs)
}
    `;
export type UpdateCompanyImgsMutationFn = Apollo.MutationFunction<UpdateCompanyImgsMutation, UpdateCompanyImgsMutationVariables>;

/**
 * __useUpdateCompanyImgsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyImgsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyImgsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyImgsMutation, { data, loading, error }] = useUpdateCompanyImgsMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      imgs: // value for 'imgs'
 *   },
 * });
 */
export function useUpdateCompanyImgsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyImgsMutation, UpdateCompanyImgsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyImgsMutation, UpdateCompanyImgsMutationVariables>(UpdateCompanyImgsDocument, options);
      }
export type UpdateCompanyImgsMutationHookResult = ReturnType<typeof useUpdateCompanyImgsMutation>;
export type UpdateCompanyImgsMutationResult = Apollo.MutationResult<UpdateCompanyImgsMutation>;
export type UpdateCompanyImgsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyImgsMutation, UpdateCompanyImgsMutationVariables>;
export const UpdateDeliveryDocument = gql`
    mutation UpdateDelivery($input: UpdateDeliveryInput) {
  updateDelivery(input: $input) {
    delivery {
      id
    }
    error {
      code
      message
    }
  }
}
    `;
export type UpdateDeliveryMutationFn = Apollo.MutationFunction<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;

/**
 * __useUpdateDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryMutation, { data, loading, error }] = useUpdateDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>(UpdateDeliveryDocument, options);
      }
export type UpdateDeliveryMutationHookResult = ReturnType<typeof useUpdateDeliveryMutation>;
export type UpdateDeliveryMutationResult = Apollo.MutationResult<UpdateDeliveryMutation>;
export type UpdateDeliveryMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;
export const UpdateDeviceDocument = gql`
    mutation UpdateDevice($input: UpdateDeviceInput) {
  updateDevice(input: $input) {
    device {
      id
      deviceId
      deviceName
      location {
        id
        name
      }
      department {
        id
        name
      }
      deviceTypes
    }
    error {
      message
      code
    }
  }
}
    `;
export type UpdateDeviceMutationFn = Apollo.MutationFunction<UpdateDeviceMutation, UpdateDeviceMutationVariables>;

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMutation, { data, loading, error }] = useUpdateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(UpdateDeviceDocument, options);
      }
export type UpdateDeviceMutationHookResult = ReturnType<typeof useUpdateDeviceMutation>;
export type UpdateDeviceMutationResult = Apollo.MutationResult<UpdateDeviceMutation>;
export type UpdateDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($id: ID!, $input: SpacesResourceInput) {
  updateResource(_id: $id, input: $input) {
    error {
      code
      message
    }
    resource {
      notes
      photo
      _id
    }
  }
}
    `;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const UpdateSpaceDocument = gql`
    mutation UpdateSpace($id: ID!, $input: SpacesInputType) {
  updateSpace(_id: $id, input: $input) {
    spaces {
      _id
    }
    error {
      code
      message
    }
  }
}
    `;
export type UpdateSpaceMutationFn = Apollo.MutationFunction<UpdateSpaceMutation, UpdateSpaceMutationVariables>;

/**
 * __useUpdateSpaceMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceMutation, { data, loading, error }] = useUpdateSpaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpaceMutation, UpdateSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpaceMutation, UpdateSpaceMutationVariables>(UpdateSpaceDocument, options);
      }
export type UpdateSpaceMutationHookResult = ReturnType<typeof useUpdateSpaceMutation>;
export type UpdateSpaceMutationResult = Apollo.MutationResult<UpdateSpaceMutation>;
export type UpdateSpaceMutationOptions = Apollo.BaseMutationOptions<UpdateSpaceMutation, UpdateSpaceMutationVariables>;
export const UpdateSpaceCategoryDocument = gql`
    mutation UpdateSpaceCategory($id: ID!, $input: SpacesCategoryInputType) {
  updateSpaceCategory(_id: $id, input: $input) {
    error {
      code
      message
    }
    category {
      _id
      name
    }
  }
}
    `;
export type UpdateSpaceCategoryMutationFn = Apollo.MutationFunction<UpdateSpaceCategoryMutation, UpdateSpaceCategoryMutationVariables>;

/**
 * __useUpdateSpaceCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceCategoryMutation, { data, loading, error }] = useUpdateSpaceCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpaceCategoryMutation, UpdateSpaceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpaceCategoryMutation, UpdateSpaceCategoryMutationVariables>(UpdateSpaceCategoryDocument, options);
      }
export type UpdateSpaceCategoryMutationHookResult = ReturnType<typeof useUpdateSpaceCategoryMutation>;
export type UpdateSpaceCategoryMutationResult = Apollo.MutationResult<UpdateSpaceCategoryMutation>;
export type UpdateSpaceCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateSpaceCategoryMutation, UpdateSpaceCategoryMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput) {
  updateUser(input: $input) {
    error {
      code
      message
    }
    user {
      id
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateVisitorDocument = gql`
    mutation UpdateVisitor($input: UpdateVisitorInput) {
  updateVisitor(input: $input) {
    visitor {
      id
      img
    }
    error {
      code
      message
    }
  }
}
    `;
export type UpdateVisitorMutationFn = Apollo.MutationFunction<UpdateVisitorMutation, UpdateVisitorMutationVariables>;

/**
 * __useUpdateVisitorMutation__
 *
 * To run a mutation, you first call `useUpdateVisitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitorMutation, { data, loading, error }] = useUpdateVisitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVisitorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitorMutation, UpdateVisitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitorMutation, UpdateVisitorMutationVariables>(UpdateVisitorDocument, options);
      }
export type UpdateVisitorMutationHookResult = ReturnType<typeof useUpdateVisitorMutation>;
export type UpdateVisitorMutationResult = Apollo.MutationResult<UpdateVisitorMutation>;
export type UpdateVisitorMutationOptions = Apollo.BaseMutationOptions<UpdateVisitorMutation, UpdateVisitorMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOtp($email: String, $otp: String) {
  verifyOtp(email: $email, otp: $otp) {
    user {
      id
      firstName
    }
    token
    error {
      code
      message
    }
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const GetAgreementDocument = gql`
    query GetAgreement($agreementId: String) {
  getAgreement(agreementId: $agreementId) {
    _id
    title
    content
    updatedAt
    signatureType
    requireSignature
  }
}
    `;

/**
 * __useGetAgreementQuery__
 *
 * To run a query within a React component, call `useGetAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useGetAgreementQuery(baseOptions?: Apollo.QueryHookOptions<GetAgreementQuery, GetAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementQuery, GetAgreementQueryVariables>(GetAgreementDocument, options);
      }
export function useGetAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementQuery, GetAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementQuery, GetAgreementQueryVariables>(GetAgreementDocument, options);
        }
// @ts-ignore
export function useGetAgreementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgreementQuery, GetAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgreementQuery, GetAgreementQueryVariables>;
export function useGetAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgreementQuery, GetAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgreementQuery | undefined, GetAgreementQueryVariables>;
export function useGetAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgreementQuery, GetAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgreementQuery, GetAgreementQueryVariables>(GetAgreementDocument, options);
        }
export type GetAgreementQueryHookResult = ReturnType<typeof useGetAgreementQuery>;
export type GetAgreementLazyQueryHookResult = ReturnType<typeof useGetAgreementLazyQuery>;
export type GetAgreementSuspenseQueryHookResult = ReturnType<typeof useGetAgreementSuspenseQuery>;
export type GetAgreementQueryResult = Apollo.QueryResult<GetAgreementQuery, GetAgreementQueryVariables>;
export const GetAgreementsDocument = gql`
    query GetAgreements($search: String) {
  getAgreements(search: $search) {
    _id
    title
    content
    updatedAt
    signatureType
    requireSignature
  }
}
    `;

/**
 * __useGetAgreementsQuery__
 *
 * To run a query within a React component, call `useGetAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAgreementsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgreementsQuery, GetAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementsQuery, GetAgreementsQueryVariables>(GetAgreementsDocument, options);
      }
export function useGetAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementsQuery, GetAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementsQuery, GetAgreementsQueryVariables>(GetAgreementsDocument, options);
        }
// @ts-ignore
export function useGetAgreementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgreementsQuery, GetAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgreementsQuery, GetAgreementsQueryVariables>;
export function useGetAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgreementsQuery, GetAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgreementsQuery | undefined, GetAgreementsQueryVariables>;
export function useGetAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgreementsQuery, GetAgreementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgreementsQuery, GetAgreementsQueryVariables>(GetAgreementsDocument, options);
        }
export type GetAgreementsQueryHookResult = ReturnType<typeof useGetAgreementsQuery>;
export type GetAgreementsLazyQueryHookResult = ReturnType<typeof useGetAgreementsLazyQuery>;
export type GetAgreementsSuspenseQueryHookResult = ReturnType<typeof useGetAgreementsSuspenseQuery>;
export type GetAgreementsQueryResult = Apollo.QueryResult<GetAgreementsQuery, GetAgreementsQueryVariables>;
export const GetArchivedEmployeesDocument = gql`
    query GetArchivedEmployees($offset: Int, $limit: Int, $search: String) {
  getArchivedEmployees(offset: $offset, limit: $limit, search: $search) {
    count
    user {
      id
      firstName
      email
      archivedAt
      lastName
      isArchived
    }
  }
}
    `;

/**
 * __useGetArchivedEmployeesQuery__
 *
 * To run a query within a React component, call `useGetArchivedEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedEmployeesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetArchivedEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>(GetArchivedEmployeesDocument, options);
      }
export function useGetArchivedEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>(GetArchivedEmployeesDocument, options);
        }
// @ts-ignore
export function useGetArchivedEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>;
export function useGetArchivedEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetArchivedEmployeesQuery | undefined, GetArchivedEmployeesQueryVariables>;
export function useGetArchivedEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>(GetArchivedEmployeesDocument, options);
        }
export type GetArchivedEmployeesQueryHookResult = ReturnType<typeof useGetArchivedEmployeesQuery>;
export type GetArchivedEmployeesLazyQueryHookResult = ReturnType<typeof useGetArchivedEmployeesLazyQuery>;
export type GetArchivedEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetArchivedEmployeesSuspenseQuery>;
export type GetArchivedEmployeesQueryResult = Apollo.QueryResult<GetArchivedEmployeesQuery, GetArchivedEmployeesQueryVariables>;
export const GetBookingSpacesDocument = gql`
    query GetBookingSpaces($space: ID, $resource: ID, $employee: ID, $location: ID, $start: String, $end: String) {
  getBookingSpaces(
    space: $space
    resource: $resource
    employee: $employee
    location: $location
    start: $start
    end: $end
  ) {
    start
    _id
    end
    category {
      _id
      name
    }
    space {
      _id
      name
    }
    resource {
      _id
      name
    }
    location {
      id
      name
    }
    employee {
      id
      firstName
      lastName
      img
    }
  }
}
    `;

/**
 * __useGetBookingSpacesQuery__
 *
 * To run a query within a React component, call `useGetBookingSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingSpacesQuery({
 *   variables: {
 *      space: // value for 'space'
 *      resource: // value for 'resource'
 *      employee: // value for 'employee'
 *      location: // value for 'location'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetBookingSpacesQuery(baseOptions?: Apollo.QueryHookOptions<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>(GetBookingSpacesDocument, options);
      }
export function useGetBookingSpacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>(GetBookingSpacesDocument, options);
        }
// @ts-ignore
export function useGetBookingSpacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>;
export function useGetBookingSpacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBookingSpacesQuery | undefined, GetBookingSpacesQueryVariables>;
export function useGetBookingSpacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>(GetBookingSpacesDocument, options);
        }
export type GetBookingSpacesQueryHookResult = ReturnType<typeof useGetBookingSpacesQuery>;
export type GetBookingSpacesLazyQueryHookResult = ReturnType<typeof useGetBookingSpacesLazyQuery>;
export type GetBookingSpacesSuspenseQueryHookResult = ReturnType<typeof useGetBookingSpacesSuspenseQuery>;
export type GetBookingSpacesQueryResult = Apollo.QueryResult<GetBookingSpacesQuery, GetBookingSpacesQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($location: ID!) {
  getCategories(location: $location) {
    id
    name
    enabled
    approval
    host
    fields {
      id
      name
      label
      type
      enabled
      required
      priority
      clearResponseAfterEachVisit
    }
    priority
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables> & ({ variables: GetCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery | undefined, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCompanyDetailsDocument = gql`
    query GetCompanyDetails {
  getCompanyDetails {
    id
    name
  }
}
    `;

/**
 * __useGetCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
      }
export function useGetCompanyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
        }
// @ts-ignore
export function useGetCompanyDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>;
export function useGetCompanyDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDetailsQuery | undefined, GetCompanyDetailsQueryVariables>;
export function useGetCompanyDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
        }
export type GetCompanyDetailsQueryHookResult = ReturnType<typeof useGetCompanyDetailsQuery>;
export type GetCompanyDetailsLazyQueryHookResult = ReturnType<typeof useGetCompanyDetailsLazyQuery>;
export type GetCompanyDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDetailsSuspenseQuery>;
export type GetCompanyDetailsQueryResult = Apollo.QueryResult<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>;
export const GetDeliveriesDocument = gql`
    query GetDeliveries($search: String, $limit: Int, $offset: Int, $collected: Boolean, $endDate: String, $startDate: String, $sorted: SortedInput, $location: ID) {
  getDeliveries(
    search: $search
    limit: $limit
    offset: $offset
    collected: $collected
    endDate: $endDate
    startDate: $startDate
    sorted: $sorted
    location: $location
  ) {
    delivery {
      id
      signature
      reciepient {
        id
        firstName
        lastName
        img
      }
      deliveryType
      note
      delivered
      collected
      collectedAt
      createdAt
      location {
        id
        name
      }
    }
    count
  }
}
    `;

/**
 * __useGetDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      collected: // value for 'collected'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      sorted: // value for 'sorted'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveriesQuery, GetDeliveriesQueryVariables>(GetDeliveriesDocument, options);
      }
export function useGetDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveriesQuery, GetDeliveriesQueryVariables>(GetDeliveriesDocument, options);
        }
// @ts-ignore
export function useGetDeliveriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveriesQuery, GetDeliveriesQueryVariables>;
export function useGetDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveriesQuery | undefined, GetDeliveriesQueryVariables>;
export function useGetDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveriesQuery, GetDeliveriesQueryVariables>(GetDeliveriesDocument, options);
        }
export type GetDeliveriesQueryHookResult = ReturnType<typeof useGetDeliveriesQuery>;
export type GetDeliveriesLazyQueryHookResult = ReturnType<typeof useGetDeliveriesLazyQuery>;
export type GetDeliveriesSuspenseQueryHookResult = ReturnType<typeof useGetDeliveriesSuspenseQuery>;
export type GetDeliveriesQueryResult = Apollo.QueryResult<GetDeliveriesQuery, GetDeliveriesQueryVariables>;
export const GetDepartmentsDocument = gql`
    query GetDepartments($offset: Int, $limit: Int, $search: String, $location: ID) {
  getDepartments(
    offset: $offset
    limit: $limit
    search: $search
    location: $location
  ) {
    count
    department {
      id
      name
      location {
        name
        id
      }
      user {
        id
        firstName
      }
    }
  }
}
    `;

/**
 * __useGetDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
      }
export function useGetDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
        }
// @ts-ignore
export function useGetDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export function useGetDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDepartmentsQuery | undefined, GetDepartmentsQueryVariables>;
export function useGetDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
        }
export type GetDepartmentsQueryHookResult = ReturnType<typeof useGetDepartmentsQuery>;
export type GetDepartmentsLazyQueryHookResult = ReturnType<typeof useGetDepartmentsLazyQuery>;
export type GetDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetDepartmentsSuspenseQuery>;
export type GetDepartmentsQueryResult = Apollo.QueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const GetDevicesDocument = gql`
    query GetDevices($location: ID!) {
  getDevices(location: $location) {
    id
    deviceTypes
    deviceName
    deviceId
    department {
      name
      id
    }
    location {
      id
      name
    }
    categoryType {
      name
      id
    }
    visitorNotifications {
      checkInPending
      checkIn
      checkOut
    }
  }
}
    `;

/**
 * __useGetDevicesQuery__
 *
 * To run a query within a React component, call `useGetDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetDevicesQuery(baseOptions: Apollo.QueryHookOptions<GetDevicesQuery, GetDevicesQueryVariables> & ({ variables: GetDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevicesQuery, GetDevicesQueryVariables>(GetDevicesDocument, options);
      }
export function useGetDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevicesQuery, GetDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevicesQuery, GetDevicesQueryVariables>(GetDevicesDocument, options);
        }
// @ts-ignore
export function useGetDevicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDevicesQuery, GetDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevicesQuery, GetDevicesQueryVariables>;
export function useGetDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevicesQuery, GetDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevicesQuery | undefined, GetDevicesQueryVariables>;
export function useGetDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevicesQuery, GetDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevicesQuery, GetDevicesQueryVariables>(GetDevicesDocument, options);
        }
export type GetDevicesQueryHookResult = ReturnType<typeof useGetDevicesQuery>;
export type GetDevicesLazyQueryHookResult = ReturnType<typeof useGetDevicesLazyQuery>;
export type GetDevicesSuspenseQueryHookResult = ReturnType<typeof useGetDevicesSuspenseQuery>;
export type GetDevicesQueryResult = Apollo.QueryResult<GetDevicesQuery, GetDevicesQueryVariables>;
export const GetEmployeesTimelineDocument = gql`
    query GetEmployeesTimeline($offset: Int, $limit: Int, $search: String, $startDate: String, $endDate: String, $sorted: SortedInput, $location: ID, $signedType: String) {
  getEmployeesTimeline(
    offset: $offset
    limit: $limit
    search: $search
    startDate: $startDate
    endDate: $endDate
    sorted: $sorted
    location: $location
    signedType: $signedType
  ) {
    count
    employee {
      id
      location {
        id
        name
      }
      employee {
        firstName
        lastName
        img
        email
        id
      }
      signedIn
      signedOut
      signedInDevice
      signedOutDevice
      signedType
      statusMessage
      returnTime
      signInQue {
        answer
        label
        type
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesTimelineQuery__
 *
 * To run a query within a React component, call `useGetEmployeesTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesTimelineQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sorted: // value for 'sorted'
 *      location: // value for 'location'
 *      signedType: // value for 'signedType'
 *   },
 * });
 */
export function useGetEmployeesTimelineQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>(GetEmployeesTimelineDocument, options);
      }
export function useGetEmployeesTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>(GetEmployeesTimelineDocument, options);
        }
// @ts-ignore
export function useGetEmployeesTimelineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>;
export function useGetEmployeesTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeesTimelineQuery | undefined, GetEmployeesTimelineQueryVariables>;
export function useGetEmployeesTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>(GetEmployeesTimelineDocument, options);
        }
export type GetEmployeesTimelineQueryHookResult = ReturnType<typeof useGetEmployeesTimelineQuery>;
export type GetEmployeesTimelineLazyQueryHookResult = ReturnType<typeof useGetEmployeesTimelineLazyQuery>;
export type GetEmployeesTimelineSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesTimelineSuspenseQuery>;
export type GetEmployeesTimelineQueryResult = Apollo.QueryResult<GetEmployeesTimelineQuery, GetEmployeesTimelineQueryVariables>;
export const GetFieldDocument = gql`
    query GetField($categoryId: ID) {
  getField(categoryId: $categoryId) {
    id
    name
    label
    type
    enabled
    required
    clearResponseAfterEachVisit
  }
}
    `;

/**
 * __useGetFieldQuery__
 *
 * To run a query within a React component, call `useGetFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetFieldQuery(baseOptions?: Apollo.QueryHookOptions<GetFieldQuery, GetFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
      }
export function useGetFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldQuery, GetFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
        }
// @ts-ignore
export function useGetFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFieldQuery, GetFieldQueryVariables>): Apollo.UseSuspenseQueryResult<GetFieldQuery, GetFieldQueryVariables>;
export function useGetFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldQuery, GetFieldQueryVariables>): Apollo.UseSuspenseQueryResult<GetFieldQuery | undefined, GetFieldQueryVariables>;
export function useGetFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldQuery, GetFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
        }
export type GetFieldQueryHookResult = ReturnType<typeof useGetFieldQuery>;
export type GetFieldLazyQueryHookResult = ReturnType<typeof useGetFieldLazyQuery>;
export type GetFieldSuspenseQueryHookResult = ReturnType<typeof useGetFieldSuspenseQuery>;
export type GetFieldQueryResult = Apollo.QueryResult<GetFieldQuery, GetFieldQueryVariables>;
export const GetIntegrationsDocument = gql`
    query GetIntegrations {
  getIntegrations {
    googleChat {
      webhooks {
        name
        webhookUrl
      }
      enabled
    }
    msTeams {
      teamId
      tenantId
      enabled
      channels {
        channelId
        channelName
      }
    }
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery | undefined, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsSuspenseQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetOfficeLocationDocument = gql`
    query GetOfficeLocation($locationId: ID!) {
  getOfficeLocation(locationId: $locationId) {
    id
    name
    address
    customHeading
    devices {
      id
      deviceName
    }
    agreements
    returningVisitors {
      saveDetails
      displayNameMatches
    }
    selectHost {
      showList
      requireVisitors
      displayHostStatus
      allowOnStaticQR
    }
    visitorPhoto
    employees {
      generalSetting {
        workRemotely
        signOutTime
        updatePicture
        verifyPhoto
      }
      pocket {
        signIn
        verifyEmployee
        preRegister
      }
      signInQue {
        label
        type
        required
        disabled
      }
      signOutMsg {
        required
        msgs {
          required
          msg
          _id
        }
      }
    }
    selectedAgreement {
      signature
      agreement
    }
    deliveries {
      general {
        scanDelivery
        allowDelivery
        deliveryContact {
          name
          email
          phone
        }
      }
      deliveryInst {
        recipientDelivery {
          noSignature
          signatureRquired
          recipientOut
        }
        generalDelivery {
          noSignature
          signatureRquired
        }
      }
    }
    savedImgs {
      id
      enabled
      url
    }
    contactLess {
      enabled
      qrCode
      token
    }
    branding {
      accentColor
      allowScanning
      badgeType
      displaysOn
      logo
    }
    signInNotifications {
      recipients {
        email
        phone
      }
      enabled
    }
    visitorButton {
      buttonRadius
      buttonColor
      buttonBg
    }
    approvals {
      allowHostsToApprove
      includeAllVisitorResponses
      sendApprovalAlerts {
        recipients {
          phone
          email
        }
        enabled
      }
    }
    signOutSettings {
      autoSignOutTime {
        enabled
        time
      }
      notifyIfNotSignedOut {
        enabled
        hours
      }
      notifyOnSignOut
    }
  }
}
    `;

/**
 * __useGetOfficeLocationQuery__
 *
 * To run a query within a React component, call `useGetOfficeLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficeLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficeLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetOfficeLocationQuery(baseOptions: Apollo.QueryHookOptions<GetOfficeLocationQuery, GetOfficeLocationQueryVariables> & ({ variables: GetOfficeLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>(GetOfficeLocationDocument, options);
      }
export function useGetOfficeLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>(GetOfficeLocationDocument, options);
        }
// @ts-ignore
export function useGetOfficeLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>;
export function useGetOfficeLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfficeLocationQuery | undefined, GetOfficeLocationQueryVariables>;
export function useGetOfficeLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>(GetOfficeLocationDocument, options);
        }
export type GetOfficeLocationQueryHookResult = ReturnType<typeof useGetOfficeLocationQuery>;
export type GetOfficeLocationLazyQueryHookResult = ReturnType<typeof useGetOfficeLocationLazyQuery>;
export type GetOfficeLocationSuspenseQueryHookResult = ReturnType<typeof useGetOfficeLocationSuspenseQuery>;
export type GetOfficeLocationQueryResult = Apollo.QueryResult<GetOfficeLocationQuery, GetOfficeLocationQueryVariables>;
export const GetOfficeLocationsDocument = gql`
    query GetOfficeLocations {
  getOfficeLocations {
    id
    name
    address
    customHeading
    devices {
      id
      deviceName
    }
    agreements
    returningVisitors {
      saveDetails
      displayNameMatches
    }
    selectHost {
      showList
      requireVisitors
      displayHostStatus
      allowOnStaticQR
    }
    visitorPhoto
    employees {
      generalSetting {
        workRemotely
        signOutTime
        updatePicture
        verifyPhoto
      }
      pocket {
        signIn
        verifyEmployee
        preRegister
      }
      signInQue {
        label
        type
        required
        disabled
        priority
      }
      signOutMsg {
        required
        msgs {
          required
          msg
          _id
        }
      }
    }
    selectedAgreement {
      signature
      agreement
    }
    deliveries {
      general {
        scanDelivery
        allowDelivery
        deliveryContact {
          name
          email
          phone
        }
      }
      deliveryInst {
        recipientDelivery {
          noSignature
          signatureRquired
          recipientOut
        }
        generalDelivery {
          noSignature
          signatureRquired
        }
      }
    }
    savedImgs {
      id
      enabled
      url
    }
    contactLess {
      enabled
      qrCode
      token
    }
  }
}
    `;

/**
 * __useGetOfficeLocationsQuery__
 *
 * To run a query within a React component, call `useGetOfficeLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficeLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficeLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfficeLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>(GetOfficeLocationsDocument, options);
      }
export function useGetOfficeLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>(GetOfficeLocationsDocument, options);
        }
// @ts-ignore
export function useGetOfficeLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>;
export function useGetOfficeLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfficeLocationsQuery | undefined, GetOfficeLocationsQueryVariables>;
export function useGetOfficeLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>(GetOfficeLocationsDocument, options);
        }
export type GetOfficeLocationsQueryHookResult = ReturnType<typeof useGetOfficeLocationsQuery>;
export type GetOfficeLocationsLazyQueryHookResult = ReturnType<typeof useGetOfficeLocationsLazyQuery>;
export type GetOfficeLocationsSuspenseQueryHookResult = ReturnType<typeof useGetOfficeLocationsSuspenseQuery>;
export type GetOfficeLocationsQueryResult = Apollo.QueryResult<GetOfficeLocationsQuery, GetOfficeLocationsQueryVariables>;
export const GetPreVisitorsDocument = gql`
    query GetPreVisitors($company: ID!, $startDate: String, $endDate: String, $search: String, $category: String, $offset: Int, $limit: Int, $sorted: SortedInput, $location: ID!) {
  getPreVisitors(
    company: $company
    startDate: $startDate
    endDate: $endDate
    search: $search
    category: $category
    offset: $offset
    limit: $limit
    sorted: $sorted
    location: $location
  ) {
    count
    visitors {
      id
      endDate
      data
      createdAt
      startDate
      startTime
      visitorEmail
      message
      department {
        name
        id
      }
      employees {
        id
        firstName
        lastName
      }
      category {
        id
        name
      }
      company {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPreVisitorsQuery__
 *
 * To run a query within a React component, call `useGetPreVisitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreVisitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreVisitorsQuery({
 *   variables: {
 *      company: // value for 'company'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sorted: // value for 'sorted'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetPreVisitorsQuery(baseOptions: Apollo.QueryHookOptions<GetPreVisitorsQuery, GetPreVisitorsQueryVariables> & ({ variables: GetPreVisitorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>(GetPreVisitorsDocument, options);
      }
export function useGetPreVisitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>(GetPreVisitorsDocument, options);
        }
// @ts-ignore
export function useGetPreVisitorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>;
export function useGetPreVisitorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreVisitorsQuery | undefined, GetPreVisitorsQueryVariables>;
export function useGetPreVisitorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>(GetPreVisitorsDocument, options);
        }
export type GetPreVisitorsQueryHookResult = ReturnType<typeof useGetPreVisitorsQuery>;
export type GetPreVisitorsLazyQueryHookResult = ReturnType<typeof useGetPreVisitorsLazyQuery>;
export type GetPreVisitorsSuspenseQueryHookResult = ReturnType<typeof useGetPreVisitorsSuspenseQuery>;
export type GetPreVisitorsQueryResult = Apollo.QueryResult<GetPreVisitorsQuery, GetPreVisitorsQueryVariables>;
export const GetResourceScheduleDocument = gql`
    query GetResourceSchedule($location: ID!, $endDate: String!, $startDate: String!, $space: ID, $resourceCategory: ID) {
  getResourceSchedule(
    location: $location
    endDate: $endDate
    startDate: $startDate
    space: $space
    resourceCategory: $resourceCategory
  ) {
    _id
    categoryName
    resourceName
    bookings {
      end
      start
    }
  }
}
    `;

/**
 * __useGetResourceScheduleQuery__
 *
 * To run a query within a React component, call `useGetResourceScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceScheduleQuery({
 *   variables: {
 *      location: // value for 'location'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      space: // value for 'space'
 *      resourceCategory: // value for 'resourceCategory'
 *   },
 * });
 */
export function useGetResourceScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetResourceScheduleQuery, GetResourceScheduleQueryVariables> & ({ variables: GetResourceScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>(GetResourceScheduleDocument, options);
      }
export function useGetResourceScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>(GetResourceScheduleDocument, options);
        }
// @ts-ignore
export function useGetResourceScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>;
export function useGetResourceScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceScheduleQuery | undefined, GetResourceScheduleQueryVariables>;
export function useGetResourceScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>(GetResourceScheduleDocument, options);
        }
export type GetResourceScheduleQueryHookResult = ReturnType<typeof useGetResourceScheduleQuery>;
export type GetResourceScheduleLazyQueryHookResult = ReturnType<typeof useGetResourceScheduleLazyQuery>;
export type GetResourceScheduleSuspenseQueryHookResult = ReturnType<typeof useGetResourceScheduleSuspenseQuery>;
export type GetResourceScheduleQueryResult = Apollo.QueryResult<GetResourceScheduleQuery, GetResourceScheduleQueryVariables>;
export const GetSpacesDocument = gql`
    query GetSpaces($location: ID!, $space: ID, $resourceCategory: ID) {
  getSpaces(
    location: $location
    space: $space
    resourceCategory: $resourceCategory
  ) {
    name
    location {
      id
      name
    }
    _id
    resource {
      name
      _id
    }
  }
}
    `;

/**
 * __useGetSpacesQuery__
 *
 * To run a query within a React component, call `useGetSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpacesQuery({
 *   variables: {
 *      location: // value for 'location'
 *      space: // value for 'space'
 *      resourceCategory: // value for 'resourceCategory'
 *   },
 * });
 */
export function useGetSpacesQuery(baseOptions: Apollo.QueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables> & ({ variables: GetSpacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpacesQuery, GetSpacesQueryVariables>(GetSpacesDocument, options);
      }
export function useGetSpacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpacesQuery, GetSpacesQueryVariables>(GetSpacesDocument, options);
        }
// @ts-ignore
export function useGetSpacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpacesQuery, GetSpacesQueryVariables>;
export function useGetSpacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpacesQuery | undefined, GetSpacesQueryVariables>;
export function useGetSpacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpacesQuery, GetSpacesQueryVariables>(GetSpacesDocument, options);
        }
export type GetSpacesQueryHookResult = ReturnType<typeof useGetSpacesQuery>;
export type GetSpacesLazyQueryHookResult = ReturnType<typeof useGetSpacesLazyQuery>;
export type GetSpacesSuspenseQueryHookResult = ReturnType<typeof useGetSpacesSuspenseQuery>;
export type GetSpacesQueryResult = Apollo.QueryResult<GetSpacesQuery, GetSpacesQueryVariables>;
export const GetSpaceCategoriesDocument = gql`
    query GetSpaceCategories($location: ID!) {
  getSpaceCategories(location: $location) {
    _id
    icon
    location {
      id
      name
    }
    name
    resources {
      name
      _id
    }
  }
}
    `;

/**
 * __useGetSpaceCategoriesQuery__
 *
 * To run a query within a React component, call `useGetSpaceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceCategoriesQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetSpaceCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables> & ({ variables: GetSpaceCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>(GetSpaceCategoriesDocument, options);
      }
export function useGetSpaceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>(GetSpaceCategoriesDocument, options);
        }
// @ts-ignore
export function useGetSpaceCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>;
export function useGetSpaceCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpaceCategoriesQuery | undefined, GetSpaceCategoriesQueryVariables>;
export function useGetSpaceCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>(GetSpaceCategoriesDocument, options);
        }
export type GetSpaceCategoriesQueryHookResult = ReturnType<typeof useGetSpaceCategoriesQuery>;
export type GetSpaceCategoriesLazyQueryHookResult = ReturnType<typeof useGetSpaceCategoriesLazyQuery>;
export type GetSpaceCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetSpaceCategoriesSuspenseQuery>;
export type GetSpaceCategoriesQueryResult = Apollo.QueryResult<GetSpaceCategoriesQuery, GetSpaceCategoriesQueryVariables>;
export const GetSpaceResourceDocument = gql`
    query GetSpaceResource($location: ID!, $features: [String], $resourceCategory: ID, $space: ID) {
  getSpaceResource(
    location: $location
    features: $features
    resourceCategory: $resourceCategory
    space: $space
  ) {
    _id
    capacity
    name
    notes
    photo
    location {
      id
      name
    }
    resourceCategory {
      _id
      name
    }
    space {
      _id
      name
    }
  }
}
    `;

/**
 * __useGetSpaceResourceQuery__
 *
 * To run a query within a React component, call `useGetSpaceResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceResourceQuery({
 *   variables: {
 *      location: // value for 'location'
 *      features: // value for 'features'
 *      resourceCategory: // value for 'resourceCategory'
 *      space: // value for 'space'
 *   },
 * });
 */
export function useGetSpaceResourceQuery(baseOptions: Apollo.QueryHookOptions<GetSpaceResourceQuery, GetSpaceResourceQueryVariables> & ({ variables: GetSpaceResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>(GetSpaceResourceDocument, options);
      }
export function useGetSpaceResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>(GetSpaceResourceDocument, options);
        }
// @ts-ignore
export function useGetSpaceResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>;
export function useGetSpaceResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetSpaceResourceQuery | undefined, GetSpaceResourceQueryVariables>;
export function useGetSpaceResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>(GetSpaceResourceDocument, options);
        }
export type GetSpaceResourceQueryHookResult = ReturnType<typeof useGetSpaceResourceQuery>;
export type GetSpaceResourceLazyQueryHookResult = ReturnType<typeof useGetSpaceResourceLazyQuery>;
export type GetSpaceResourceSuspenseQueryHookResult = ReturnType<typeof useGetSpaceResourceSuspenseQuery>;
export type GetSpaceResourceQueryResult = Apollo.QueryResult<GetSpaceResourceQuery, GetSpaceResourceQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($search: String, $limit: Int, $offset: Int, $sorted: SortedInput, $location: ID, $role: RoleEnum) {
  getUsers(
    search: $search
    limit: $limit
    offset: $offset
    sorted: $sorted
    location: $location
    role: $role
  ) {
    count
    user {
      id
      firstName
      img
      email
      createdAt
      location {
        id
        name
      }
      company {
        name
        id
      }
      department {
        id
        name
      }
      role
      phone
      updatedAt
      lastName
      notificationPreference
      workingRemote
      timeline {
        id
        signedIn
        returnTime
        signedOut
        signedType
        statusMessage
      }
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorted: // value for 'sorted'
 *      location: // value for 'location'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetVistorsDocument = gql`
    query GetVistors($startDate: String, $endDate: String, $search: String, $signedType: String, $category: String, $limit: Int, $offset: Int, $remembered: Boolean, $sorted: SortedInput, $location: String) {
  getVistors(
    startDate: $startDate
    endDate: $endDate
    search: $search
    signedType: $signedType
    category: $category
    limit: $limit
    offset: $offset
    remembered: $remembered
    sorted: $sorted
    location: $location
  ) {
    count
    visitor {
      id
      img
      signedType
      signedInDevice
      signedOutDevice
      anonymize
      location {
        id
        name
      }
      department {
        name
        id
      }
      data
      signedIn
      category {
        id
        name
      }
      signedOut
      employees {
        id
        firstName
        lastName
      }
      selectedAgreement {
        agreement
        signatureImg
      }
    }
  }
}
    `;

/**
 * __useGetVistorsQuery__
 *
 * To run a query within a React component, call `useGetVistorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVistorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVistorsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      search: // value for 'search'
 *      signedType: // value for 'signedType'
 *      category: // value for 'category'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      remembered: // value for 'remembered'
 *      sorted: // value for 'sorted'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetVistorsQuery(baseOptions?: Apollo.QueryHookOptions<GetVistorsQuery, GetVistorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVistorsQuery, GetVistorsQueryVariables>(GetVistorsDocument, options);
      }
export function useGetVistorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVistorsQuery, GetVistorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVistorsQuery, GetVistorsQueryVariables>(GetVistorsDocument, options);
        }
// @ts-ignore
export function useGetVistorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVistorsQuery, GetVistorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVistorsQuery, GetVistorsQueryVariables>;
export function useGetVistorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVistorsQuery, GetVistorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVistorsQuery | undefined, GetVistorsQueryVariables>;
export function useGetVistorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVistorsQuery, GetVistorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVistorsQuery, GetVistorsQueryVariables>(GetVistorsDocument, options);
        }
export type GetVistorsQueryHookResult = ReturnType<typeof useGetVistorsQuery>;
export type GetVistorsLazyQueryHookResult = ReturnType<typeof useGetVistorsLazyQuery>;
export type GetVistorsSuspenseQueryHookResult = ReturnType<typeof useGetVistorsSuspenseQuery>;
export type GetVistorsQueryResult = Apollo.QueryResult<GetVistorsQuery, GetVistorsQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    img
    email
    createdAt
    location {
      id
      name
    }
    company {
      name
      id
    }
    department {
      id
      name
    }
    role
    phone
    updatedAt
    lastName
    notificationPreference
    workingRemote
    timeline {
      id
      signedIn
      returnTime
      signedOut
      signedType
      statusMessage
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;